import { useState, useEffect, useMemo } from 'react';
import Navbar from "../../component/HeaderData";
import Footer from "../../component/FooterData";
import BackButton from '../../component/Common/BackBtn'
import PageSubTitle from '../../component/Common/PageSubTitle'
import Button from '../../component/Common/Button'
import InputText from '../../component/Common/InputText'
import InputMask from 'react-input-mask';
import Modal from 'react-modal';
import MultiSelectDropdown from '../../component/Common/CheckboxDropdown';
import Dropdown from '../../component/Common/Dropdown';
import { useHistory, useLocation } from 'react-router-dom'
import { useLooksUpData } from '../../utils/getLookupTableData';
import { useReportInventoryService } from '../../services/ReportInventoryServices';
import { formatDateForDisplay } from '../../utils/dateUtils';
import newStateUserTx from '../../utils/UserChangeRequestJsonTemplates/UserChangeRequest_NewStateUserTx.json';
import { toast } from 'react-toastify';
import { isMainThread } from 'worker_threads';
import { AnyListenerPredicate } from '@reduxjs/toolkit';
import confirmYesNo from '../../component/Common/ConfirmYesNo';

export default function UserAccountChangeRequest() {
    const history = useHistory()
    const location = useLocation();
    const recordData = (location?.state as any)?.recordData || null;
    const { getMasterTableLookupValueData, getMasterTableLookupData, getUserGroupTableLookupData, getOrganizationUnitsTableLookupData } = useLooksUpData();
    const ReportInventoryService = useReportInventoryService();
    const [userChangeRequestdetails, setUserChangeRequestdetails] = useState<any>({})
    const [originalPayload, setOriginalPayload] = useState(null);
    const [isInitialized, setIsInitialized] = useState(false);
    const [isLoading, setIsLoading] = useState(false)
    const loggedInUserDetails = JSON.parse(sessionStorage.getItem('loginUserDetails') || '{}');
    const getTodayDate = () => {
        const centralString = new Date().toLocaleString('en-US', {
            timeZone: 'America/Chicago'
        });

        const centralDate = new Date(centralString);

        const year = centralDate.getFullYear();
        const month = String(centralDate.getMonth() + 1).padStart(2, '0');
        const day = String(centralDate.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    };

    const [originalMaster, setOriginalMaster] = useState<Record<string, string> | null>(null);
    const [userDetail, setUserDetail] = useState(newStateUserTx.userDetail.after);

    const [originalReviewAssignments, setOriginalReviewAssignments] = useState([]);
    const [reviewAssignmentsReq, setReviewAssignmentsReq] = useState([]);

    const [originalGroupMemberships, setOriginalGroupMemberships] = useState([]);
    const [groupMemberships, setGroupMemberships] = useState([]);
    const [notes, setNotes] = useState('');
    const [usaStateList, setUsaStateList] = useState<any>([]);
    let [mcoStaffCategoryList, setMcoStaffCategoryList] = useState<any>([]);
    let envPrefix = process.env.REACT_APP_ENV_PREFIX || '';
    const [roleGroupChanges, setRoleGroupChanges] = useState<RoleGroupChange[]>([]);
    const [mcoAuthorityChanges, setMcoAuthorityChanges] = useState<MCOAuthorityChange[]>([]);
    const [isNewRoleModalOpen, setIsNewRoleModalOpen] = useState(false);
    const [isEndRoleModalOpen, setIsEndRoleModalOpen] = useState(false);
    const [isNewMcoAuthorityModalOpen, setIsNewMcoAuthorityModalOpen] = useState(false);
    const [isEndMcoAuthorityModalOpen, setIsEndMcoAuthorityModalOpen] = useState(false);
    const [newMcoAuthorities, setNewMcoAuthorities] = useState<MCOAuthorityChange[]>([]);
    const [endMcoAuthority, setEndMcoAuthority] = useState('');

    const [reviewAssignmentsList, setReviewAssignmentsList] = useState<ReviewAssignmentChange[]>([]);
    const [isNewReviewModalOpen, setIsNewReviewModalOpen] = useState(false);
    const [isEndReviewModalOpen, setIsEndReviewModalOpen] = useState(false);

    const [newRoles, setNewRoles] = useState<string[]>([]);
    const [newFromDate, setNewFromDate] = useState(getTodayDate());
    const [newToDate, setNewToDate] = useState('2999-12-31');

    const [endRole, setEndRole] = useState('');
    const [endFromDate, setEndFromDate] = useState(new Date().toISOString().slice(0, 10));
    const [currentEndToDate, setCurrentEndToDate] = useState('2999-12-31');
    const [revisedEndToDate, setRevisedEndToDate] = useState('2999-12-31');

    const [newReviewerGroups, setNewReviewerGroups] = useState<string[]>([]);
    const [newReviewPlans, setNewReviewPlans] = useState<string[]>([]);
    const [newReviewFromDate, setNewReviewFromDate] = useState(getTodayDate());
    const [newReviewToDate, setNewReviewToDate] = useState('2999-12-31');

    const [endReviewerGroup, setEndReviewerGroup] = useState('');
    const [endReviewPlan, setEndReviewPlan] = useState('');
    const [endReviewFromDate, setEndReviewFromDate] = useState(new Date().toISOString().slice(0, 10));
    const [currentReviewEndToDate, setCurrentReviewEndToDate] = useState('2999-12-31');
    const [revisedReviewEndToDate, setRevisedReviewEndToDate] = useState('2999-12-31');

    const [selectedRoleId, setSelectedRoleId] = useState<string>('');
    const [selectedReviewId, setSelectedReviewId] = useState<string>('');
    const [selectedMcoAuthorityId, setSelectedMcoAuthorityId] = useState<string>('');

    const selectedRoleRow = roleGroupChanges.find((r) => r.userGroupCode + '-' + r.effectiveFromDate + '-' + r.effectiveToDate === selectedRoleId);
    const selectedReviewRow = reviewAssignmentsList.find((r) => r.reviewerGroupCd + '-' + r.planId + '-' + r.id === selectedReviewId);
    const selectedMcoAuthorityRow = mcoAuthorityChanges.find((r) => r.id + '-' + r.effectiveFromDate + '-' + r.effectiveToDate === selectedMcoAuthorityId);

    const [changeNotes, setChangeNotes] = useState('');

    let [changeRequestTypeList, setChangeRequestTypeList] = useState<any>([]);
    let [accountTypeList, setAccountTypeList] = useState<any>([]);
    const [userChangeRequestStatusList, setUserChangeRequestStatusList] = useState<any>([])
    const [userRoleGroupsList, setUserRoleGroupsList] = useState<any>([])
    const [organizationUnitsList, setOrganizationUnitsList] = useState<any>([]);
    const [mcPlansList, setMcPlansList] = useState<any>([]);
    const [mcoStaffUserDetailsList, setMcoStaffUserDetailsList] = useState<any>([]);
    const [loadingButton, setLoadingButton] = useState(false);

    const [newMcoAuthFromDate, setNewMcoAuthFromDate] = useState(getTodayDate());
    const [newMcoAuthToDate, setNewMcoAuthToDate] = useState('2999-12-31');
    const [mcoAuthEditEmailId, setMcoAuthEditEmailId] = useState('');
    const [mcoAuthEditName, setMcoAuthEditName] = useState('');
    const [mcoAuthEditTitle, setMcoAuthEditTitle] = useState('');
    const [mcoAuthEditStaffCtgry, setMcoAuthEditStaffCtgry] = useState('');
    const [mcoAuthFileEditName, setMcoAuthFileEditName] = useState('');
    const [mcoAuthFromEditDate, setMcoAuthFromEditDate] = useState('');
    const [mcoAuthToEditDate, setMcoAuthToEditDate] = useState('');
    const [revisedStaffEndToDate, setRevisedStaffEndToDate] = useState('2999-12-31');
    const [mcoAuthTmErrorMessage, setMcoAuthTmErrorMessage] = useState('');
    const [changeRequestActionType, setChangeRequestActionType] = useState<string | null>('A');
    const [mcoAuthDocFileNames, setMcoAuthDocFileNames] = useState<string[]>([]);
    const [didSavedBeforeCancel, setDidSavedBeforeCancel] = useState(false);
    const DEFAULT_TO_DATE = '2999-12-31';
    const [newValues, setNewValues] = useState<Record<UserDetailKey, string>>({
        firstName: '',
        middleName: '',
        lastName: '',
        title: '',
        staffCategory: '',
        contactPhone: '',
        street1: '',
        street2: '',
        street3: '',
        city: '',
        state: '',
        zip: '',
        areaCode: '',
        effectiveFromDate: changeRequestActionType === 'L' ? '' : getTodayDate() || '',
        effectiveToDate: changeRequestActionType === 'L' ? '' : DEFAULT_TO_DATE || '',
    });


    function stripEmptyFields(beforeObj: any, afterObj: any) {
        const cleaned: Record<string, any> = {};

        Object.keys(afterObj).forEach(key => {
            const beforeVal = beforeObj[key];
            const afterVal = afterObj[key];

            // If user left field untouched → skip it
            if (afterVal === "" && beforeVal !== "" && beforeVal !== null && beforeVal !== undefined) {
                return;
            }

            // If user typed something meaningful or cleared intentionally → keep it
            if (afterVal !== "") {
                cleaned[key] = afterVal;
            }
        });

        return cleaned;
    }

    function getChangedFields(
        beforeObj: Record<string, any> = {},
        afterObj: Record<string, any> = {}
    ) {

        const before = { ...beforeObj };
        const after: Record<string, any> = {};

        Object.keys(afterObj).forEach(key => {
            const beforeVal = beforeObj[key];
            const afterVal = afterObj[key];

            // Case 1: IGNORE null/empty unless it was actually changed from a value
            const isMeaningfulNullChange =
                (afterVal === null || afterVal === "") &&
                beforeVal !== null &&
                beforeVal !== "";

            if (isMeaningfulNullChange) {
                // Only include this if user intentionally cleared the field
                after[key] = afterVal;
                return;
            }

            // Case 2: Regular meaningful change
            if (afterVal !== beforeVal && afterVal !== null && afterVal !== "") {
                after[key] = afterVal;
            }
        });

        return {
            beforeChanges: before,
            afterChanges: after
        };
    }

    function getChanges(beforeObj: Record<string, any>, afterObj: Record<string, any>) {
        const before: Record<string, any> = {};
        const after: Record<string, any> = {};

        // Only compare fields that exist in BEFORE object
        Object.keys(beforeObj).forEach(key => {
            const beforeValue = beforeObj[key];
            const afterValue = afterObj[key];

            if (beforeValue !== afterValue) {
                before[key] = beforeValue;
                after[key] = afterValue;
            }
        });

        return { before, after };
    }

    const normalizePhone = (value?: string) => {
        if (!value) return value;
        return value.replace(/\D/g, "");
    };

    const getLocalIso = () => {
        const now = new Date();

        const centralString = now.toLocaleString('sv-SE', {
            timeZone: 'America/Chicago'
        });

        const ms = String(now.getMilliseconds()).padStart(3, '0');
        return centralString.replace(' ', 'T') + `.${ms}`;
    };

    function getEndDiff(original: any, cleanedAfter: any) {
        const before = { ...original };
        const after: any = {};

        for (const key of Object.keys(cleanedAfter)) {
            if (original[key] !== cleanedAfter[key]) {
                after[key] = cleanedAfter[key];   // only changed fields
            }
        }

        return { before, after };
    }

    function computeDiff(original: any, updated: any) {
        const before: any = {};
        const after: any = {};

        Object.keys(updated).forEach(key => {
            const oldVal = original?.[key] ?? null;
            const newVal = updated[key] ?? null;

            // Only capture changed values
            if (oldVal !== newVal) {
                before[key] = oldVal;
                after[key] = newVal;
            }
        });

        return { before, after, hasChanges: Object.keys(after).length > 0 };
    }

    function buildMasterPayload() {

        if (newValues?.contactPhone) {
            newValues.contactPhone = normalizePhone(newValues.contactPhone) ?? "";
        }

        const isNew =
            userChangeRequestdetails?.chngRqstTypeLkpcd === "A" &&
            changeRequestActionType !== "L" &&
            changeRequestActionType !== "M" &&
            changeRequestActionType !== "U";

        if (isNew) {
            return {
                action: "NEW",
                before: null,
                after: convertEmptyToNull(newValues)
            };
        }

        const cleanedNewValues = stripEmptyFields(currentValues, newValues);
        const changes = getChangedFields(currentValues, cleanedNewValues);

        if (changes.afterChanges?.contactPhone) {
            changes.afterChanges.contactPhone = normalizePhone(changes.afterChanges.contactPhone);
        }

        if (changes.beforeChanges?.state) {
            changes.beforeChanges.state = matchingUsaStateLkpcdValue(changes.beforeChanges.state);
        }

        if (changes.beforeChanges?.staffCategory) {
            changes.beforeChanges.staffCategory = matchingMcoStaffCategoryLkpcdValue(changes.beforeChanges.staffCategory);
        }

        return {
            action: "MODIFY",
            before: convertEmptyToNull(changes.beforeChanges),
            after: changeRequestActionType === "M" ? changes.afterChanges : null
        };
    }

    function buildReviewAssignmentsPayload() {
        return reviewAssignmentsList.map((item: any) => {

            const isNewRequest =
                userChangeRequestdetails?.chngRqstTypeLkpcd === "A" &&
                changeRequestActionType !== "L" &&
                changeRequestActionType !== "M" &&
                changeRequestActionType !== "U";

            const isNewItem = !item.original;

            // CLEAN THE ITEM (remove extra fields)
            const cleanedAfter = {
                reviewerGroupCd: item.reviewerGroupCd,
                planId: item.planId,
                effectiveFromDate: item.effectiveFromDate,
                effectiveToDate: item.effectiveToDate,
                createdBy:
                    item.after && item.after.createdBy
                        ? item.after.createdBy
                        : loggedInUserDetails?.userEmail || "",
                createdDate:
                    item.after && item.after.createdDate
                        ? item.after.createdDate
                        : getLocalIso(),
                proposedAction: item.proposedAction
            };

            if (isNewRequest) {
                return {
                    action: "NEW",
                    reviewAssignmentSid: null,
                    before: null,
                    after: cleanedAfter
                };
            }

            // CASE 2: MODIFY request, but THIS item is NEW
            if (isNewItem) {
                return {
                    action: "NEW",
                    reviewAssignmentSid: null,
                    before: null,
                    after: cleanedAfter
                };
            }

            const diffChanges = computeDiff(item.original, cleanedAfter);

            // If nothing changed → skip this item entirely
            if (!diffChanges.hasChanges) {
                return {
                    action: 'NEW',
                    reviewAssignmentSid: item?.reviewAssignmentSid || item?.reviewassignmentsid || null,
                    before: item.original,
                    after: cleanedAfter
                };
            }

            // CASE 3: NO change in effectiveToDate → ignore (same as group)
            if ((item.original?.effectiveToDate || null) === (cleanedAfter?.effectiveToDate || null)) {
                return {
                    action: null,
                    reviewAssignmentSid: item?.reviewAssignmentSid || item?.reviewassignmentsid || null,
                    before: item.original,
                    after: null
                };
            }

            // CASE 4: change → END (same as group)
            const diff = getEndDiff(item.original, cleanedAfter);

            return {
                action: "END",
                reviewAssignmentSid: item?.reviewAssignmentSid || item?.reviewassignmentsid || null,
                before: diff.before,
                after: {
                    effectiveToDate: cleanedAfter?.effectiveToDate,
                    proposedAction: cleanedAfter.proposedAction,
                    createdBy: cleanedAfter.createdBy,
                    createdDate: cleanedAfter.createdDate
                }
            };

        }).filter(x => x !== null);
    }

    function buildGroupMembershipPayload() {
        if (!roleGroupChanges || roleGroupChanges.length === 0) {
            return [];
        }

        return roleGroupChanges.map((item: any) => {
            const isNewRequest =
                userChangeRequestdetails?.chngRqstTypeLkpcd === "A" &&
                changeRequestActionType !== "L" &&
                changeRequestActionType !== "M" &&
                changeRequestActionType !== "U";

            const isExisting = !item.original;

            const cleanedAfter = {
                userGroupCode: item.userGroupCode,
                effectiveFromDate: item.effectiveFromDate,
                effectiveToDate: item.effectiveToDate,
                proposedAction: item.proposedAction,
                createdBy:
                    item.after && item.after.createdBy
                        ? item.after.createdBy
                        : loggedInUserDetails?.userEmail || "",
                createdDate:
                    item.after && item.after.createdDate
                        ? item.after.createdDate
                        : getLocalIso()
            };

            // ---------- NEW RECORD ----------

            if (isNewRequest) {
                return {
                    action: "NEW",
                    xUserGroupSid: null,
                    before: null,
                    after: cleanedAfter
                };
            }

            // change: new record must be action=NEW and kept in AFTER object
            if (isExisting) {
                return {
                    action: "NEW",
                    xUserGroupSid: null,
                    before: null,
                    after: cleanedAfter
                };
            }

            // Existing record
            const original = item.original;

            const updatedEffectiveTo = cleanedAfter.effectiveToDate;
            const originalEffectiveTo = original.effectiveToDate;

            const hasEffectiveToChange =
                (originalEffectiveTo || null) !== (updatedEffectiveTo || null);

            // ---------- Existing record TO-date changed → END ----------
            if (hasEffectiveToChange) {
                return {
                    action: "END",
                    xUserGroupSid: item?.xUserGroupSid || item?.xuserGroupSid || item?.xusergroupsid ||
                        original?.xUserGroupSid || original?.xuserGroupSid || original?.xusergroupsid || null,
                    before: original,
                    after: {
                        effectiveToDate: updatedEffectiveTo,
                        proposedAction: cleanedAfter.proposedAction,
                        createdBy: cleanedAfter.createdBy,
                        createdDate: cleanedAfter.createdDate
                    }
                };
            }

            // ---------- Existing record unchanged → NEW ----------
            return {
                action: null,
                xUserGroupSid: item?.xUserGroupSid || item?.xuserGroupSid || item?.xusergroupsid || null,
                before: original,
                after: null
            };
        });
    }

    function encodeIfNotBase64(value: string | null | undefined): string {
        if (!value) return '';

        const trimmedValue = value.trim();

        // Uploaded file locations are plain URLs/paths and must be encoded.
        const isUrlOrPath =
            trimmedValue.includes('/') ||
            trimmedValue.includes('\\') ||
            /^https?:\/\//i.test(trimmedValue);

        if (!isUrlOrPath &&
            trimmedValue.length % 4 === 0 &&
            /^[A-Za-z0-9+/]*={0,2}$/.test(trimmedValue)) {
            try {
                const decoded = atob(trimmedValue);

                if (btoa(decoded) === trimmedValue) {
                    return trimmedValue;
                }
            } catch {
                // Encode below.
            }
        }

        return btoa(unescape(encodeURIComponent(value)));
    }

    function buildMcoAuthorityPayload() {
        return mcoAuthorityChanges.map((item: any) => {

            const isNewRequest =
                userChangeRequestdetails?.chngRqstTypeLkpcd === "A" &&
                changeRequestActionType !== "L" &&
                changeRequestActionType !== "M" &&
                changeRequestActionType !== "U";

            const isNewItem = !item.original;

            const cleanedAfter = {
                firstName: item.firstName,
                lastName: item.lastName,
                email: item.email,
                title: item.title,
                documentation: item.documentation,
                fileLocation: encodeIfNotBase64(item.fileLocation || ""),
                effectiveFromDate: item.effectiveFromDate,
                effectiveToDate: item.effectiveToDate,
                proposedAction: item.proposedAction,
                createdBy:
                    item.after && item.after.createdBy
                        ? item.after.createdBy
                        : loggedInUserDetails?.userEmail || "",
                createdDate:
                    item.after && item.after.createdDate
                        ? item.after.createdDate
                        : getLocalIso(),
            };

            // CASE 1: Entire request is NEW → everything NEW
            if (isNewRequest) {
                return {
                    action: "NEW",
                    xUserSid: null,
                    before: null,
                    after: cleanedAfter
                };
            }

            // CASE 2: MODIFYING → new item
            if (isNewItem) {
                return {
                    action: "NEW",
                    xUserSid: null,
                    before: null,
                    after: cleanedAfter
                };
            }

            const original = item.original;

            const updatedEffectiveTo = cleanedAfter.effectiveToDate;
            const originalEffectiveTo = original.effectiveToDate;

            const hasEffectiveToChange =
                (originalEffectiveTo || null) !== (updatedEffectiveTo || null);

            // ---------- Existing record TO-date changed → END ----------
            if (hasEffectiveToChange) {
                const encodedBefore = {
                    ...original,
                    fileLocation: encodeIfNotBase64(
                        original.fileLocation || original.documentLocation || ''
                    )
                };
                return {
                    action: "END",
                    xUserSid: item?.xuserSid || item?.xUserSid || item?.xusersid || original?.xuserSid || original?.xUserSid || original?.xusersid || null,
                    before: encodedBefore,
                    after: {
                        effectiveToDate: cleanedAfter.effectiveToDate,
                        proposedAction: cleanedAfter.proposedAction,
                        createdBy: cleanedAfter.createdBy,
                        createdDate: cleanedAfter.createdDate
                    }
                };
            }

            // Now check diffs AFTER the END check
            const diffChanges = computeDiff(original, cleanedAfter);

            // CASE 3: NO CHANGE in effectiveToDate → ignore
            if ((originalEffectiveTo || null) === (updatedEffectiveTo || null)) {

                const original = item.original;

                const encodedBefore = {
                    ...original,
                    fileLocation: encodeIfNotBase64(
                        original.fileLocation || original.documentLocation || ''
                    )
                };

                return {
                    action: null,
                    xUserSid: item?.xuserSid || item?.xUserSid || item?.xusersid || original?.xuserSid || original?.xUserSid || original?.xusersid || null,
                    before: encodedBefore,
                    after: null
                };
            }

            // If nothing changed → skip this item entirely
            if (!diffChanges.hasChanges) {
                const original = item.original;

                const encodedBefore = {
                    ...original,
                    fileLocation: encodeIfNotBase64(
                        original.fileLocation || original.documentLocation || ''
                    )
                };

                return {
                    action: null,
                    xUserSid: item?.xuserSid || item?.xUserSid || item?.xusersid || original?.xuserSid || original?.xUserSid || original?.xusersid || null,
                    before: encodedBefore,
                    after: null
                };
            }

        }).filter(x => x !== null);
    }

    type UserDetailKey =
        | 'firstName'
        | 'middleName'
        | 'lastName'
        | 'title'
        | 'staffCategory'
        | 'contactPhone'
        | 'street1'
        | 'street2'
        | 'street3'
        | 'city'
        | 'state'
        | 'zip'
        | 'areaCode'
        | 'effectiveFromDate'
        | 'effectiveToDate'
    // | 'organizationUnitCode'
    // | 'userId'
    // | 'oprtnlUserFlag'
    // | 'accountTypeLkpcd'
    // | 'chngRqstTypeLkpcd'
    // | 'afStatusLkpcd'
    // | 'createdBy'
    // | 'createdDate'
    // | 'updatedBy'
    // | 'updatedDate'
    // | 'changeReasonSummary';

    const userDetailRows: Array<{ label: string; key: UserDetailKey; type?: string; mask?: string; select?: string[] }> = [
        { label: 'First Name*', key: 'firstName' },
        { label: 'Middle Name', key: 'middleName' },
        { label: 'Last Name*', key: 'lastName' },
        { label: 'Title*', key: 'title' },
        ...(userChangeRequestdetails?.accountTypeLkpcd === 'T'
            ? [{
                label: 'Staff Category*', key: 'staffCategory' as UserDetailKey,
                select: mcoStaffCategoryList.map((s: any) => ({
                    label: s.lkdmn_lkpcd_desc,
                    value: String(s.lkpdmn_lkpcd),
                }))
            }]
            : []),
        { label: userChangeRequestdetails?.accountTypeLkpcd === 'T' ? 'Cell Phone Number*' : 'Contact Phone Number', key: 'contactPhone', mask: '(999) 999-9999' },
        { label: 'Street Address 1', key: 'street1' },
        { label: 'Street Address 2', key: 'street2' },
        { label: 'Street Address 3', key: 'street3' },
        { label: 'City', key: 'city' },
        {
            label: 'State',
            key: 'state',
            select: usaStateList.map((s: any) => ({
                label: s.lkdmn_lkpcd_desc,
                value: String(s.lkpdmn_lkpcd),
            }))
        },
        { label: 'Zip', key: 'zip' },
        { label: 'Area Code', key: 'areaCode' },
        { label: 'Effective From Date*', key: 'effectiveFromDate', type: 'date' },
        { label: 'Effective To Date*', key: 'effectiveToDate', type: 'date' },
    ];


    const parsedPayload = useMemo(() => {
        try {
            return userChangeRequestdetails?.payload
                ? JSON.parse(userChangeRequestdetails.payload)
                : null;
        } catch (e) {
            console.error("Failed to parse payload", e);
            return null;
        }
    }, [userChangeRequestdetails]);

    useEffect(() => {
        setOriginalPayload(parsedPayload);
    }, [parsedPayload]);

    function getDisplayCurrentValue(field: UserDetailKey) {

        if ((changeRequestActionType === 'L' && userChangeRequestdetails?.afStatusLkpcd === 'O')
            || (changeRequestActionType === 'U' && userChangeRequestdetails?.afStatusLkpcd === 'A'
                || userChangeRequestdetails?.afStatusLkpcd === 'O'
            )) {
            const beforeValue = parsedPayload?.userDetail?.before?.[field];

            if (beforeValue !== undefined && beforeValue !== null) {
                return beforeValue;
            }
        }

        if ((changeRequestActionType === 'M' || changeRequestActionType === 'L') && parsedPayload?.userDetail?.action != 'MODIFY') {
            const afterValue = parsedPayload?.userDetail?.after?.[field];

            if (afterValue !== undefined && afterValue !== null) {
                return afterValue;
            }
        }

        // FIX: Prevent mm/dd/yyyy display under "Adding"
        if (field === 'effectiveFromDate' || field === 'effectiveToDate') {
            return null;
        }


        return '';
    }

    function getDisplayNewValue(field: UserDetailKey) {
        const afterValue = parsedPayload?.userDetail?.after?.[field];

        if (afterValue !== undefined && afterValue !== null && afterValue !== '') {
            return afterValue;
        }

        return '';
    }


    function getSavedRolesNewValue() {
        const saved = parsedPayload?.groupMemberships;
        if (!saved || saved.length === 0) return [];

        if (changeRequestActionType === 'A') {
            return saved.map((g: any, index: number) => ({
                id: g.after?.userGroupCode || `role-${index}`,
                ...g.after,
                original: g.before ?? g.after
            }));
        }

        if (changeRequestActionType === 'M') {
            return saved.map((g: any, index: number) => {

                // new group added during modify
                if (g.action === "NEW") {
                    return {
                        ...g,
                        id: g.before?.userGroupCode || `role-${index}`,
                        ...g.before,
                        ...g.after,    // merge changes
                        xUserGroupSid: g.xUserGroupSid || g.xuserGroupSid,
                        original: g.before
                    };
                }

                // existing group modified
                if (g.action === "MODIFYING" || g.action === "MODIFY" || g.action === "END" || g.action === null) {
                    return {
                        ...g,
                        id: g.before?.userGroupCode || `role-${index}`,
                        ...g.before,
                        ...g.after,    // merge changes
                        xUserGroupSid: g.xUserGroupSid || g.xuserGroupSid,
                        original: g.before
                    };
                }

                return null;
            }).filter(Boolean);
        }

        if ((changeRequestActionType === 'L' && userChangeRequestdetails?.afStatusLkpcd === 'O')
            || (changeRequestActionType === 'U' && userChangeRequestdetails?.afStatusLkpcd === 'A'
                || userChangeRequestdetails?.afStatusLkpcd === 'O'
            ) && changeRequestActionType !== 'M') {
            return saved.map((g: any, index: number) => ({
                id: g.before?.userGroupCode || `role-${index}`,
                ...g.before,
                original: g.before ?? g.before
            }));
        }
    }

    function getSavedeviewAssignmentsNewValue() {
        const saved = parsedPayload?.reviewAssignments;

        if (!saved || saved.length === 0) return [];

        if (changeRequestActionType === 'A') {
            return saved.map((g: any, index: number) => ({
                id: `${g.after?.reviewerGroupCd || 'review'}-${g.after?.planId || index}-${index}`,
                ...g.after,
                original: g.before ?? g.after
            }));
        }

        if (changeRequestActionType === 'M') {
            return saved.map((g: any, index: number) => {

                // new group added during modify
                if (g.action === "NEW") {
                    return {
                        id: `${g.after?.reviewerGroupCd || 'review'}-${g.after?.planId || index}-${index}`,
                        ...g.before,
                        ...g.after,
                        original: g.before,
                        reviewAssignmentSid: g.reviewAssignmentSid
                    };
                }

                // existing group modified
                if (g.action === "MODIFYING" || g.action === "MODIFY" || g.action === "END" || g.action === null) {
                    return {
                        id: `${g.before?.reviewerGroupCd || 'review'}-${g.before?.planId || index}-${index}`,
                        ...g.before,
                        ...g.after,    // merge changes
                        original: g.before,
                        reviewAssignmentSid: g.reviewAssignmentSid
                    };
                }

                return null;
            }).filter(Boolean);
        }

        if ((changeRequestActionType === 'L' && userChangeRequestdetails?.afStatusLkpcd === 'O')
            || (changeRequestActionType === 'U' && userChangeRequestdetails?.afStatusLkpcd === 'A'
                || userChangeRequestdetails?.afStatusLkpcd === 'O'
            ) && changeRequestActionType !== 'M') {
            return saved.map((g: any, index: number) => ({
                id: `${g.before?.reviewerGroupCd || 'review'}-${g.before?.planId || index}-${index}`,
                ...g.before,
                original: g.before ?? g.before
            }));
        }
    }

    function getSavedMcoAuthorityNewValue() {
        const saved = parsedPayload?.mcoAuthorities;

        if (!saved || saved.length === 0) return [];

        if (changeRequestActionType === 'A') {
            return saved.map((g: any, index: number) => ({
                id: g.after?.email || `mco-${index}`,
                ...g.after,
                original: g.before ?? g.after
            }));
        }


        if (changeRequestActionType === 'M') {
            return saved.map((g: any, index: number) => {

                const before = g.before || {};
                const after = g.after || {};

                // NEW entry
                if (g.action === "NEW") {
                    return {
                        ...g,
                        id: after.relatedUserSid || `mco-${index}`,
                        ...g.before,
                        ...g.after,
                        // map fileLocation correctly
                        fileLocation: after.fileLocation || after.documentLocation || null,
                        name: after.relatedUserName || "",
                        original: g.before,
                        xUserSid: g.xuserSid || g.xUserSid
                    };
                }

                // END entry
                if (g.action === "END") {
                    return {
                        ...g,
                        id: before.relatedUserSid || `mco-${index}`,
                        ...before,
                        ...g.after,
                        toDate: after.effectiveToDate,       // only date changes!
                        fileLocation: before.fileLocation || before.documentLocation || null,
                        name: before.relatedUserName || "",
                        original: before,
                        xUserSid: g.xuserSid || g.xUserSid
                    };
                }

                // MODIFYING entry
                if (g.action === "MODIFYING" || g.action === "MODIFY" || g.action === null) {

                    const merged = { ...before };

                    // safely merge only existing fields
                    Object.keys(after).forEach(k => {
                        if (after[k] != null) merged[k] = after[k];
                    });

                    return {
                        id: merged.relatedUserSid || `mco-${index}`,
                        ...merged,
                        fileLocation: merged.fileLocation || merged.documentLocation || null,
                        name: merged.relatedUserName || "",
                        original: before,
                        xUserSid: g.xuserSid || g.xUserSid
                    };
                }

                return {
                    id: before.relatedUserSid || `mco-${index}`,
                    ...before,
                    fileLocation: before.fileLocation || before.documentLocation || null,
                    name: before.relatedUserName || "",
                    original: before,
                    xUserSid: g.xuserSid || g.xUserSid
                };
            }).filter(Boolean);
        }

        if ((changeRequestActionType === 'L' && userChangeRequestdetails?.afStatusLkpcd === 'O')
            || (changeRequestActionType === 'U' && userChangeRequestdetails?.afStatusLkpcd === 'A'
                || userChangeRequestdetails?.afStatusLkpcd === 'O'
            ) && changeRequestActionType !== 'M') {
            return saved.map((g: any, index: number) => ({
                id: g.before?.email || `mco-${index}`,
                ...g.before,
                original: g.before ?? g.before
            }));
        }
    }

    const getGroupLabel = (groupCode: string) => {
        const found = userRoleGroupsList.find((g: any) => g.value === groupCode);
        return found ? found.label : groupCode;
    };

    const getReviewGroupLabel = (organizationUnitCode: string) => {
        const found = organizationUnitsList.find((g: any) => g.value === organizationUnitCode);
        return found ? found.label : organizationUnitCode;
    };

    const getPlanLabel = (planId: string) => {
        const found = mcPlansList.find((g: any) => g.value === planId);
        return found ? found.label : planId;
    };

    const normalizeStateValue = (raw: any) => {
        const value = String(raw ?? '').trim().toLowerCase();
        if (!value) return '';

        const match = usaStateList.find((state: any) =>
            String(state.lkpdmn_lkpcd ?? '').trim().toLowerCase() === value ||
            String(state.lkdmn_lkpcd_desc ?? '').trim().toLowerCase() === value
        );

        return match ? String(match.lkpdmn_lkpcd).trim() : value;
    };

    const getMatchingDescription = (list: any[], data: any) => {
        const matchedItem = list.find((code: any) => code.lkpdmn_lkpcd === data);
        return matchedItem?.lkdmn_lkpcd_desc || data;
    };

    const getMatchingLkpcd = (list: any[], data: any) => {
        const matchedItem = list.find((code: any) => code.lkdmn_lkpcd_desc === data);
        return matchedItem?.lkpdmn_lkpcd || data;
    };

    const matchingUsaStateLkpcd = (data: any) => getMatchingDescription(usaStateList, data);

    function formatDisplayDate(isoDate: string | null | undefined) {
        if (!isoDate) return "";
        const [yyyy, mm, dd] = isoDate.split("-");
        return `${mm}/${dd}/${yyyy}`;
    }

    function convertEmptyToNull(obj: any) {
        const cleaned: Record<string, any> = {};
        for (const key in obj) {
            cleaned[key] = obj[key] === "" ? null : obj[key];
        }
        return cleaned;
    }

    const isAnyAddressFieldFilled = (values: Partial<Record<UserDetailKey, string>>) => {
        return (
            values.street1?.trim() !== '' ||
            values.street2?.trim() !== '' ||
            values.street3?.trim() !== '' ||
            values.city?.trim() !== '' ||
            values.zip?.trim() !== ''
        );
    };

    function validateAddressOnSubmit(values: any): string | null {
        const hasAnyAddressValues =
            values.street1 ||
            values.street2 ||
            values.street3 ||
            values.city ||
            values.state ||
            values.zip;

        if (!hasAnyAddressValues) {
            return null;
        }

        if (!values.street1) {
            return "Street Address 1 must be entered before completing the address.";
        }

        if (values.street2 && !values.street1) {
            return "Enter Address 1 first before entering Address 2.";
        }

        if (values.street3 && !values.street2) {
            return "Enter Address 2 first before entering Address 3.";
        }

        if (values.city && !values.street1) {
            return "Enter Address 1 first before entering City.";
        }

        if (values.state && !values.street1) {
            return "Enter Address 1 first before selecting State.";
        }

        if (values.zip && !values.street1) {
            return "Enter Address 1 first before entering Zip.";
        }

        if (!values.city || !values.state || !values.zip) {
            return "Street Address 1, City, State, and Zip must all be filled.";
        }

        return null;
    }

    const createInitialMcoStaffNewValues = () => ({
        userEmailId: "",
        userEmailId_userFirstName: "",
        userEmailId_userLastName: "",
        userEmailId_userJobTitle: "",
        userEmailId_userStaffCategory: "",
        uploadFileUrl: "",
        mcoAuthorityEffectiveFromDate: getTodayDate() || '',
        mcoAuthorityEffectiveToDate: DEFAULT_TO_DATE || '',
    });

    const [mcoStaffNewValues, setMcoStaffNewValues] = useState(createInitialMcoStaffNewValues);

    type ProposedAction = 'Adding' | 'Ending' | null;

    interface RoleGroupChange {
        id: string;
        userGroupCode: string;
        effectiveFromDate: string;
        effectiveToDate: string;
        proposedAction: ProposedAction;
    }
    //   reviewerGroupCd: item.reviewerGroupCd,
    //                 planId: item.planId,
    //                 effectiveFromDate: item.effectiveFromDate,
    //                 effectiveToDate: item.effectiveToDate,
    //                 createdBy: loggedInUserDetails?.userEmail || "",
    //                 createdDate: getLocalIso()
    //                 proposedAction: item.proposedAction
    interface ReviewAssignmentChange {
        id: string;
        reviewerGroupCd: string;
        planId: string;
        effectiveFromDate: string;
        effectiveToDate: string;
        proposedAction: ProposedAction;
    }

    interface MCOAuthorityChange {
        id: string;
        email: string;
        name: string;
        firstName: string;
        lastName: string;
        title: string;
        staffCategory: string;
        documentation: string;
        fileLocation: string;
        effectiveFromDate: string;
        effectiveToDate: string;
        proposedAction: ProposedAction;
    }

    const handleOpenNewRoleModal = () => {
        setNewRoles([]);

        setNewFromDate(newValues.effectiveFromDate || getTodayDate());
        setNewToDate('2999-12-31');

        setIsNewRoleModalOpen(true);
    };

    const handleConfirmNewRole = () => {
        if (newRoles.length === 0) return;

        const today = getTodayDate();

        // Validation: From date must not be less than today
        if (newFromDate && newFromDate < today) {
            const msg = 'Effective From Date cannot be less than current date.';
            toast.error(msg, { toastId: msg });
            return;
        }

        // Validation: To date cannot be less than from date
        if (newFromDate && newToDate && newToDate < newFromDate) {
            const msg = 'Effective To Date cannot be less than Effective From Date.';
            toast.error(msg, { toastId: msg });
            return;
        }

        // Validation: From date cannot be greater than To date
        if (newFromDate && newToDate && newFromDate > newToDate) {
            const msg = 'Effective From Date cannot be greater than Effective To Date.';
            toast.error(msg, { toastId: msg });
            return;
        }

        const overlappingDuplicateExists = roleGroupChanges.some((existing) =>
            newRoles.includes(existing.userGroupCode) &&
            (existing.proposedAction === "Adding" ||
                existing.proposedAction === "Ending" ||
                existing.proposedAction === null ||
                existing.proposedAction === '' ||
                existing.proposedAction === "" ||
                existing.proposedAction === undefined) &&
            newFromDate <= existing.effectiveToDate &&
            newToDate >= existing.effectiveFromDate
        );

        if (overlappingDuplicateExists) {
            toast.error("An overlapping User Role Group exists.");
            return;
        }

        const rowsToAdd: RoleGroupChange[] = newRoles.map((role) => ({
            id: `${role}-ADD-${Date.now()}-${Math.random()}`,
            userGroupCode: role,
            effectiveFromDate: newFromDate,
            effectiveToDate: newToDate,
            proposedAction: 'Adding',
        }));

        setRoleGroupChanges((prev) => {
            const deduped = [...prev];

            rowsToAdd.forEach((row) => {
                deduped.push(row);
            });

            return deduped;
        });

        setIsNewRoleModalOpen(false);
    };

    const handleOpenEndRoleModal = () => {
        if (!selectedRoleRow) return;

        const today = new Date();
        const endDate = selectedRoleRow.effectiveToDate ? new Date(selectedRoleRow.effectiveToDate) : null;

        // Record already ended if endDate < today
        if (endDate && endDate < today) {
            toast.error("Already ended record can't be ended again.");
            return;
        }

        setEndRole(selectedRoleRow.userGroupCode);
        setEndFromDate(selectedRoleRow.effectiveFromDate);
        setCurrentEndToDate(selectedRoleRow.effectiveToDate);
        setRevisedEndToDate(getTodayDate());
        setIsEndRoleModalOpen(true);
    };

    const handleSaveEndRole = () => {
        if (!selectedRoleRow || !revisedEndToDate) return;

        const today = getTodayDate();

        // Validation: To date must not be less than today
        if (revisedEndToDate && revisedEndToDate < today) {
            const msg = 'Effective To Date cannot be less than current date.';
            toast.error(msg, { toastId: msg });
            return;
        }

        // Validation: Revised end date must be earlier than Current Effective End Date
        if (
            selectedRoleRow.effectiveToDate &&
            revisedEndToDate &&
            revisedEndToDate >= selectedRoleRow.effectiveToDate
        ) {
            const msg = 'Revised Effective To Date must be earlier than current Effective End Date.';
            toast.error(msg, { toastId: msg });
            return;
        }

        // Validation: To date cannot be less than from date
        if (selectedRoleRow.effectiveFromDate && revisedEndToDate && revisedEndToDate < selectedRoleRow.effectiveFromDate) {
            const msg = 'Effective To Date cannot be less than Effective From Date.';
            toast.error(msg, { toastId: msg });
            return;
        }

        setRoleGroupChanges((prev) =>
            prev.map((row) =>
                row.userGroupCode + '-' + row.effectiveFromDate + '-' + row.effectiveToDate ===
                    selectedRoleRow.userGroupCode + '-' + selectedRoleRow.effectiveFromDate + '-' + selectedRoleRow.effectiveToDate
                    ? {
                        ...row,
                        ...{
                            effectiveToDate: revisedEndToDate,
                            proposedAction: 'Ending'
                        }
                    }

                    : row
            )
        );

        setIsEndRoleModalOpen(false);
        setSelectedRoleId('');
    };

    const canUndo = (row?: { proposedAction?: ProposedAction }) =>
        !!row && (row.proposedAction === 'Adding' || row.proposedAction === 'Ending' || row.proposedAction === null);

    const handleUndoRoleGroupChanges = async () => {
        if (!selectedRoleRow || !canUndo(selectedRoleRow)) return;

        const message = selectedRoleRow.proposedAction === 'Adding'
            ? 'Are you sure you do not want to add this record anymore?'
            : 'Are you sure you do not want to end this record anymore?';

        if (!await confirmYesNo(message)) return;

        setRoleGroupChanges((prev: any) =>
            selectedRoleRow.proposedAction === 'Adding'
                ? prev.filter((row: any) => row.id !== selectedRoleRow.id)
                : prev.map((row: any) =>
                    row.userGroupCode + '-' + row.effectiveFromDate + '-' + row.effectiveToDate ===
                        selectedRoleRow.userGroupCode + '-' + selectedRoleRow.effectiveFromDate + '-' + selectedRoleRow.effectiveToDate
                        ? {
                            ...row,
                            effectiveToDate: row.original?.effectiveToDate ?? row.effectiveToDate,
                            proposedAction: null,
                        }
                        : row
                )
        );

        toast.success('Changes have been undone successfully.');

        setSelectedRoleId('');
    };

    const handleOpenNewMcoAuthorityModal = () => {
        setNewMcoAuthorities([]);
        // if (newValues.staffCategory === 'TM' && mcoAuthTmErrorMessage !== '') {
        //     toast.error(mcoAuthTmErrorMessage, { toastId: mcoAuthTmErrorMessage });
        // } else {
        //     setNewMcoAuthFromDate(newValues.effectiveFromDate || getTodayDate());
        //     setNewMcoAuthToDate('2999-12-31');
        //     setIsNewMcoAuthorityModalOpen(true);
        //     setMcoAuthTmErrorMessage('');
        // }

        if (!newValues.staffCategory && changeRequestActionType !== 'M') {
            toast.error("Please select MCO Staff Category before adding authorization.");
            return;
        }

        if (newValues.staffCategory === 'TM' || (!newValues.staffCategory && matchingMcoStaffCategoryLkpcdValue(currentValues.staffCategory) === 'TM')) {
            toast.error("Top management users do not require other authorization.");
            return;
        }

        setNewMcoAuthFromDate(newValues.effectiveFromDate || getTodayDate());
        setNewMcoAuthToDate('2999-12-31');
        setIsNewMcoAuthorityModalOpen(true);
        setMcoAuthTmErrorMessage('');

    };

    const handleCloseNewMcoAuthorityModal = () => {
        setNewMcoAuthorities([]);
        setMcoStaffNewValues(createInitialMcoStaffNewValues());
        setIsNewMcoAuthorityModalOpen(false);
        setMcoAuthorityFile(null);
    };

    const handleUndoMcoAuthorityChanges = async () => {
        if (!selectedMcoAuthorityRow || !canUndo(selectedMcoAuthorityRow)) return;

        const message = selectedMcoAuthorityRow.proposedAction === 'Adding'
            ? 'Are you sure you do not want to add this record anymore?'
            : 'Are you sure you do not want to end this record anymore?';

        if (!await confirmYesNo(message)) return;

        setMcoAuthorityChanges((prev: any) =>
            selectedMcoAuthorityRow.proposedAction === 'Adding'
                ? prev.filter((row: any) => row.id !== selectedMcoAuthorityRow.id)
                : prev.map((row: any) =>
                    row.id + '-' + row.effectiveFromDate + '-' + row.effectiveToDate === selectedMcoAuthorityId
                        ? {
                            ...row,
                            effectiveToDate: row.original?.effectiveToDate ?? row.effectiveToDate,
                            proposedAction: null,
                        }
                        : row
                )
        );

        toast.success('Changes have been undone successfully.');
        setSelectedMcoAuthorityId('');
    };

    const handleOpenNewReviewModal = () => {
        setNewReviewerGroups([]);
        setNewReviewPlans([]);
        setNewReviewFromDate(newValues.effectiveFromDate || getTodayDate());
        setNewReviewToDate('2999-12-31');
        setIsNewReviewModalOpen(true);
    };

    const handleSaveNewReview = () => {
        if (newReviewerGroups.length === 0 || newReviewPlans.length === 0) return;


        const today = getTodayDate();

        // From date cannot be less than today's date
        if (newReviewFromDate && newReviewFromDate < today) {
            const msg = 'Effective From Date cannot be less than current date.';
            toast.error(msg, { toastId: msg });
            return;
        }

        // To date cannot be less than from date
        if (newReviewFromDate && newReviewToDate && newReviewToDate < newReviewFromDate) {
            const msg = 'Effective To Date cannot be less than Effective From Date.';
            toast.error(msg, { toastId: msg });
            return;
        }

        // From date cannot be greater than To date
        if (newReviewFromDate && newReviewToDate && newReviewFromDate > newReviewToDate) {
            const msg = 'Effective From Date cannot be greater than Effective To Date.';
            toast.error(msg, { toastId: msg });
            return;
        }

        const overlappingDuplicateExists = reviewAssignmentsList.some((existing) =>
            newReviewerGroups.includes(existing.reviewerGroupCd) &&
            newReviewPlans.includes(existing.planId) &&
            (existing.proposedAction === "Adding" ||
                existing.proposedAction === "Ending" ||
                existing.proposedAction === null ||
                existing.proposedAction === '' ||
                existing.proposedAction === "" ||
                existing.proposedAction === undefined) &&
            newReviewFromDate <= existing.effectiveToDate &&
            newReviewToDate >= existing.effectiveFromDate
        );

        if (overlappingDuplicateExists) {
            toast.error("An overlapping review assignment exists for this Reviewer Group and Plan.");
            return;
        }

        const rowsToAdd: ReviewAssignmentChange[] = [];
        newReviewerGroups.forEach((reviewerGroup) => {
            newReviewPlans.forEach((plan) => {
                rowsToAdd.push({
                    id: `${reviewerGroup}-${plan}-ADD-${Date.now()}-${Math.random()}`,
                    reviewerGroupCd: reviewerGroup,
                    planId: plan,
                    effectiveFromDate: newReviewFromDate,
                    effectiveToDate: newReviewToDate,
                    proposedAction: 'Adding',
                });
            });
        });

        setReviewAssignmentsList((prev) => {
            const deduped = [...prev];
            rowsToAdd.forEach((row) => {
                const exists = deduped.some(
                    (x) =>
                        x.reviewerGroupCd === row.reviewerGroupCd &&
                        x.planId === row.planId &&
                        x.proposedAction === row.proposedAction &&
                        x.effectiveFromDate === row.effectiveFromDate &&
                        x.effectiveToDate === row.effectiveToDate
                );
                if (!exists) deduped.push(row);
            });
            return deduped;
        });

        setIsNewReviewModalOpen(false);
    };

    const handleOpenEndReviewModal = () => {
        if (!selectedReviewRow) return;
        const today = new Date();
        const endDate = selectedReviewRow.effectiveToDate ? new Date(selectedReviewRow.effectiveToDate) : null;

        // Record already ended if endDate < today
        if (endDate && endDate < today) {
            toast.error("Already ended record can't be ended again.");
            return;
        }

        setEndReviewerGroup(getReviewGroupLabel(selectedReviewRow.reviewerGroupCd));
        setEndReviewPlan(getPlanLabel(selectedReviewRow.planId));
        setEndReviewFromDate(selectedReviewRow.effectiveFromDate);
        setCurrentReviewEndToDate(selectedReviewRow.effectiveToDate);
        setRevisedReviewEndToDate(getTodayDate());
        setIsEndReviewModalOpen(true);
    };

    const handleOpenEndMcoAuthorityModal = () => {
        if (!selectedMcoAuthorityRow) return;
        const today = new Date();
        const endDate = selectedMcoAuthorityRow.effectiveToDate ? new Date(selectedMcoAuthorityRow.effectiveToDate) : null;

        // Record already ended if endDate < today
        if (endDate && endDate < today) {
            toast.error("Already ended record can't be ended again.");
            return;
        }
        setMcoAuthEditEmailId(selectedMcoAuthorityRow.email);
        setMcoAuthEditName(selectedMcoAuthorityRow.name);
        setMcoAuthEditTitle(selectedMcoAuthorityRow.title);
        setMcoAuthEditStaffCtgry(selectedMcoAuthorityRow.staffCategory);
        setMcoAuthFileEditName(selectedMcoAuthorityRow.documentation);
        setMcoAuthFromEditDate(selectedMcoAuthorityRow.effectiveFromDate);
        setMcoAuthToEditDate(selectedMcoAuthorityRow.effectiveToDate);
        setRevisedStaffEndToDate(getTodayDate());
        setIsEndMcoAuthorityModalOpen(true);
    };

    const handleSaveEndReview = () => {
        if (!selectedReviewRow || !revisedReviewEndToDate) return;

        const today = getTodayDate();

        // Validation: To date must not be less than today
        if (revisedReviewEndToDate && revisedReviewEndToDate < today) {
            const msg = 'Effective To Date cannot be less than current date.';
            toast.error(msg, { toastId: msg });
            return;
        }

        // Validation: Revised end date must be earlier than Current Effective End Date
        if (
            selectedReviewRow.effectiveToDate &&
            revisedReviewEndToDate &&
            revisedReviewEndToDate >= selectedReviewRow.effectiveToDate
        ) {
            const msg = 'Revised Effective To Date must be earlier than current Effective End Date.';
            toast.error(msg, { toastId: msg });
            return;
        }

        // Validation: To date cannot be less than from date
        if (selectedReviewRow.effectiveFromDate && revisedReviewEndToDate && revisedReviewEndToDate < selectedReviewRow.effectiveFromDate) {
            const msg = 'Effective To Date cannot be less than Effective From Date.';
            toast.error(msg, { toastId: msg });
            return;
        }

        setReviewAssignmentsList((prev) =>
            prev.map((row) =>
                row.reviewerGroupCd + '-' + row.planId + '-' + row.id === selectedReviewRow.reviewerGroupCd + '-' + selectedReviewRow.planId + '-' + selectedReviewRow.id
                    ? { ...row, effectiveToDate: revisedReviewEndToDate, proposedAction: 'Ending' as const }
                    : row
            )
        );

        setIsEndReviewModalOpen(false);
        setSelectedReviewId('');
    };

    const handleSaveEndMcoAuthority = () => {
        if (!selectedMcoAuthorityId || !revisedStaffEndToDate) return;

        const today = getTodayDate();

        // Validation: To date must not be less than today
        if (revisedStaffEndToDate && revisedStaffEndToDate < today) {
            const msg = 'Effective To Date cannot be less than current date.';
            toast.error(msg, { toastId: msg });
            return;
        }

        // Validation: Revised end date must be earlier than Current Effective End Date
        if (
            selectedMcoAuthorityRow?.effectiveToDate &&
            revisedStaffEndToDate &&
            revisedStaffEndToDate >= selectedMcoAuthorityRow?.effectiveToDate
        ) {
            const msg = 'Revised Effective To Date must be earlier than current Effective End Date.';
            toast.error(msg, { toastId: msg });
            return;
        }

        // Validation: To date cannot be less than from date
        if (selectedMcoAuthorityRow?.effectiveFromDate && revisedStaffEndToDate && revisedStaffEndToDate < selectedMcoAuthorityRow?.effectiveFromDate) {
            const msg = 'Effective To Date cannot be less than Effective From Date.';
            toast.error(msg, { toastId: msg });
            return;
        }

        setMcoAuthorityChanges((prev) =>
            prev.map((row) =>
                row.id + '-' + row.effectiveFromDate + '-' + row.effectiveToDate === selectedMcoAuthorityId
                    ? { ...row, effectiveToDate: revisedStaffEndToDate, proposedAction: 'Ending' as const }
                    : row
            )
        );

        setIsEndMcoAuthorityModalOpen(false);
        setSelectedMcoAuthorityId('');
    };

    const handleUndoReviewAssignments = async () => {
        if (!selectedReviewRow || !canUndo(selectedReviewRow)) return;

        const message = selectedReviewRow.proposedAction === 'Adding'
            ? 'Are you sure you do not want to add this record anymore?'
            : 'Are you sure you do not want to end this record anymore?';

        if (!await confirmYesNo(message)) return;

        setReviewAssignmentsList((prev: any) =>
            selectedReviewRow.proposedAction === 'Adding'
                ? prev.filter((row: any) => row.id !== selectedReviewRow.id)
                : prev.map((row: any) =>
                    row.reviewerGroupCd + '-' + row.planId + '-' + row.id ===
                        selectedReviewRow.reviewerGroupCd + '-' + selectedReviewRow.planId + '-' + selectedReviewRow.id
                        ? {
                            ...row,
                            effectiveToDate: row.original?.effectiveToDate ?? row.effectiveToDate,
                            proposedAction: null,
                        }
                        : row
                )
        );

        toast.success('Changes have been undone successfully.');
        setSelectedReviewId('');
    };

    const onNewValueChange = (key: UserDetailKey) => (e: React.ChangeEvent<HTMLInputElement>) => {
        setNewValues((prev) => ({ ...prev, [key]: e.target.value }));
    };

    const handleDateChange = (key: UserDetailKey) => (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        const today = getTodayDate();

        const next = { ...newValues, [key]: value };
        // let error = '';

        // if (key === 'effectiveFromDate') {
        //     if (value && value < today) {
        //         error = 'Effective From Date cannot be less than current date.';
        //     } else if (next.effectiveToDate && value > next.effectiveToDate) {
        //         error = 'Effective From Date cannot be greater than Effective To Date.';
        //     }
        // }

        // if (key === 'effectiveToDate') {
        //     if (next.effectiveFromDate && value < next.effectiveFromDate) {
        //         error = 'Effective To Date cannot be less than Effective From Date.';
        //     }
        // }

        // if (error) {
        //     toast.error(error, { toastId: error });
        //     return;
        // }

        setNewValues(next);
    };

    const handleRoleFromDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        const today = getTodayDate();

        // if (value && value < today) {
        //     const msg = 'Effective From Date cannot be less than current date.';
        //     toast.error(msg, { toastId: msg });
        //     return;
        // }

        // if (newToDate && value > newToDate) {
        //     const msg = 'Effective From Date cannot be greater than Effective To Date.';
        //     toast.error(msg, { toastId: msg });
        //     return;
        // }

        setNewFromDate(value);
    };

    const handleRoleToDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;

        // if (newFromDate && value < newFromDate) {
        //     const msg = 'Effective To Date cannot be less than Effective From Date.';
        //     toast.error(msg, { toastId: msg });
        //     return;
        // }

        setNewToDate(value);
    };

    const handleReviewFromDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        // const today = getTodayDate();

        // if (value && value < today) {
        //     const msg = 'Effective From Date cannot be less than current date.';
        //     toast.error(msg, { toastId: msg });
        //     return;
        // }

        // if (newReviewToDate && value > newReviewToDate) {
        //     const msg = 'Effective From Date cannot be greater than Effective To Date.';
        //     toast.error(msg, { toastId: msg });
        //     return;
        // }

        setNewReviewFromDate(value);
    };

    const handleReviewToDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;

        // if (newReviewFromDate && value < newReviewFromDate) {
        //     const msg = 'Effective To Date cannot be less than Effective From Date.';
        //     toast.error(msg, { toastId: msg });
        //     return;
        // }

        setNewReviewToDate(value);
    };

    const handleRevisedEndRoleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        // const today = getTodayDate();

        // if (value && value < today) {
        //     const msg = 'Revised Effective To Date cannot be less than current system date.';
        //     toast.error(msg, { toastId: msg });
        //     return;
        // }

        setRevisedEndToDate(value);
    };

    const handleRevisedReviewEndDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        // const today = getTodayDate();

        // if (value && value < today) {
        //     const msg = 'Revised Effective To Date cannot be less than current system date.';
        //     toast.error(msg, { toastId: msg });
        //     return;
        // }

        setRevisedReviewEndToDate(value);
    };

    const handleRevisedStaffEndDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        // const today = getTodayDate();

        // if (value && value < today) {
        //     const msg = 'Revised Effective To Date cannot be less than current system date.';
        //     toast.error(msg, { toastId: msg });
        //     return;
        // }

        setRevisedStaffEndToDate(value);
    };

    const handleMcoAuthFromDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        // const today = getTodayDate();

        // if (value && value < today) {
        //     const msg = 'Effective From Date cannot be less than current date.';
        //     toast.error(msg, { toastId: msg });
        //     return;
        // }

        // if (newMcoAuthToDate && value > newMcoAuthToDate) {
        //     const msg = 'Effective From Date cannot be greater than Effective To Date.';
        //     toast.error(msg, { toastId: msg });
        //     return;
        // }

        setNewMcoAuthFromDate(value);
    };

    const handleMcoAuthToDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;

        // if (newMcoAuthFromDate && value < newMcoAuthFromDate) {
        //     const msg = 'Effective To Date cannot be less than Effective From Date.';
        //     toast.error(msg, { toastId: msg });
        //     return;
        // }

        setNewMcoAuthToDate(value);
    };

    const handleRoleCheckboxChange = (userGroupCode: string) => {
        setSelectedRoleId((prev) => (prev === userGroupCode ? '' : userGroupCode));
    };

    const handleReviewCheckboxChange = (id: string) => {
        setSelectedReviewId((prev) => (prev === id ? '' : id));
    };

    const handleMcoAuthCheckboxChange = (id: string) => {
        setSelectedMcoAuthorityId((prev) => (prev === id ? '' : id));
    }

    const dateInputStyle: React.CSSProperties = {
        width: '100%',
        border: '1px solid #222',
        padding: '4px 6px',
        height: '30px',
        boxSizing: 'border-box',
        backgroundColor: '#fff'
    };

    const handleChangeNotes = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setChangeNotes(e.target.value);
    };

    async function handleCancel() {

        if (!hasUnsavedChanges) {
            history.goBack();
            return;
        }

        const confirmed = await confirmYesNo(
            'Unsaved changes will be lost. Are you sure you want to go Back?'
        );

        if (confirmed) {
            history.goBack();
        }
    }

    const [mcoAuthorityFile, setMcoAuthorityFile] = useState<File | null>(null);
    const handleMcoFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (file) {
            setMcoAuthorityFile(file);
        }
    };

    const handleConfirmNewMcoAuthority = async () => {
        setLoadingButton(true);

        const today = getTodayDate();

        if (newMcoAuthFromDate && newMcoAuthFromDate < today) {
            toast.error('Effective From Date cannot be less than current date.');
            setLoadingButton(false);
            return;
        }

        if (newMcoAuthFromDate && newMcoAuthToDate && newMcoAuthToDate < newMcoAuthFromDate) {
            toast.error('Effective To Date cannot be less than Effective From Date.');
            setLoadingButton(false);
            return;
        }

        if (newMcoAuthFromDate && newMcoAuthToDate && newMcoAuthFromDate > newMcoAuthToDate) {
            toast.error('Effective From Date cannot be greater than Effective To Date.');
            setLoadingButton(false);
            return;
        }

        const overlappingDuplicateExists = mcoAuthorityChanges.some((x) =>
            x.email === mcoStaffNewValues.userEmailId &&
            (x.proposedAction === "Adding" ||
                x.proposedAction === "Ending" ||
                x.proposedAction === null ||
                x.proposedAction === '' ||
                x.proposedAction === "" ||
                x.proposedAction === undefined) &&
            newMcoAuthFromDate <= x.effectiveToDate &&
            newMcoAuthToDate >= x.effectiveFromDate
        );

        if (overlappingDuplicateExists) {
            toast.error("An overlapping MCO Granting Authority record exists for this user.");
            setLoadingButton(false);
            return;
        }

        const formData = new FormData();
        if (!mcoAuthorityFile) {
            toast.error("Please select a file to upload");
            return;
        }
        formData.append("file", mcoAuthorityFile);

        const newFileName = mcoAuthorityFile.name;
        console.log('mcoAuthorityChanges::', mcoAuthorityChanges);

        const gridFileNameExists = mcoAuthorityChanges.some(
            (x) => x.documentation === newFileName
        );

        if (gridFileNameExists) {
            toast.error("This authorization document exists in the grid.");
            setLoadingButton(false);
            return;
        }

        if (mcoAuthDocFileNames.includes(newFileName)) {
            toast.error("This authorization document has been uploaded for another authorization by this user or other user. Please upload another document");
            setLoadingButton(false);
            return;
        }

        try {
            const response = await ReportInventoryService.uploadMcoAuthorityFile(formData);

            if (response?.data?.fileUrl) {
                const fileUrl = response.data.fileUrl;

                const encodedFileName = fileUrl.split('/').pop() || "";
                const decodedFileName = decodeURIComponent(encodedFileName)

                const name = [
                    mcoStaffNewValues.userEmailId_userFirstName,
                    mcoStaffNewValues.userEmailId_userLastName
                ].filter(Boolean).join(", ");

                const rowToAdd: MCOAuthorityChange = {
                    id: mcoStaffNewValues.userEmailId + "-ADD-" + Date.now() + "-" + Math.random(),
                    email: mcoStaffNewValues.userEmailId,
                    name: name,
                    firstName: mcoStaffNewValues.userEmailId_userFirstName || "",
                    lastName: mcoStaffNewValues.userEmailId_userLastName || "",
                    title: mcoStaffNewValues.userEmailId_userJobTitle || "",
                    staffCategory: mcoStaffNewValues.userEmailId_userStaffCategory || "",
                    documentation: decodedFileName,
                    effectiveFromDate: newMcoAuthFromDate,
                    effectiveToDate: newMcoAuthToDate,
                    proposedAction: "Adding",
                    fileLocation: fileUrl,
                };

                setMcoAuthorityChanges((prev) => {
                    const deduped = [...prev];
                    const exists = deduped.some(
                        (x) =>
                            x.name === rowToAdd.name &&
                            x.title === rowToAdd.title &&
                            x.documentation === rowToAdd.documentation &&
                            x.proposedAction === rowToAdd.proposedAction &&
                            x.effectiveFromDate === rowToAdd.effectiveFromDate &&
                            x.effectiveToDate === rowToAdd.effectiveToDate
                    );
                    if (!exists) deduped.push(rowToAdd);
                    return deduped;
                });

                setMcoStaffNewValues((prev) => ({
                    ...prev,
                    uploadFileUrl: fileUrl
                }));
                setIsNewMcoAuthorityModalOpen(false);
                setMcoStaffNewValues(createInitialMcoStaffNewValues());
            }
        } catch (error) {
            console.error("Error uploading file:", error);
            toast.error("Error uploading MCO authority file");
        } finally {
            setLoadingButton(false);
            setMcoAuthorityFile(null);
        }
    }

    const fetchGetMasterTableLookupValueData = async () => {
        try {
            const response = await getMasterTableLookupValueData();
            if (response) {
                const { data } = response;

                const filterAndMapData = (group: string, table: string, column: string) => {
                    return data
                        .filter((dt: any) => dt.lkpcd_group === group && dt.table_name === table && dt.column_name === column)
                        .map((code: any) => ({
                            lkpdmn_lkpcd: `${code.lkpdmn_lkpcd}`,
                            lkdmn_lkpcd_desc: code.lkdmn_lkpcd_desc,
                            lkpcd_group: code.lkpcd_group,
                        }));
                };

                // const mcActionLKPCD = filterAndMapData('NG', 'MC_USER', 'ACCOUNT_STATUS_LKPCD');
                // const mcAfStatusLKPCD = filterAndMapData('NG', 'MC_USER', 'AF_STATUS_LKPCD');
                // const mcAccountStatusLKPCD = filterAndMapData('NG', 'MC_USER', 'ACCOUNT_STATUS_LKPCD');
                const mcAccountTypeLKPCD = filterAndMapData('NG', 'MC_USER', 'ACCOUNT_TYPE_LKPCD');
                const mcMcoStaffCategoryLKPCD = filterAndMapData('NG', 'MC_USER', 'MCO_STAFF_CTGRY_LKPCD');
                const userChangeAfStatusLKPCD = filterAndMapData('NG', 'MC_USER_CHANGE_REQUEST', 'AF_STATUS_LKPCD');
                const userChangeStateLKPCD = filterAndMapData('NG', 'MC_USER', 'STATE_LKPCD');

                const mcChangeRequestTypeLKPCD = filterAndMapData('NG', 'MC_USER_CHANGE_REQUEST', 'CHNG_RQST_TYPE_LKPCD');
                setChangeRequestTypeList(mcChangeRequestTypeLKPCD);
                setAccountTypeList(mcAccountTypeLKPCD);
                setUserChangeRequestStatusList(userChangeAfStatusLKPCD);
                setUsaStateList(userChangeStateLKPCD);
                setMcoStaffCategoryList(mcMcoStaffCategoryLKPCD);
            }
        } catch (e) {
            console.log(e);
        }
    };

    const getChangerequestUserDetails = async (chngRqstSid: any) => {
        try {
            const response = await ReportInventoryService.getUserChangeRequestById(chngRqstSid);
            if (response) {
                const { data } = response;
                setUserChangeRequestdetails(data)
            }
        } catch (e) {
            console.log(e);
        }
    };

    const matchingChangeRequestTypeLkpcd = (data: any) => getMatchingDescription(changeRequestTypeList, data);
    const matchingAccountTypeLkpcd = (data: any) => getMatchingDescription(accountTypeList, data);
    const matchingUserChangeRequestStatusLkpcd = (data: any) => getMatchingDescription(userChangeRequestStatusList, data);
    const matchingMcoStaffCategoryLkpcd = (data: any) => getMatchingDescription(mcoStaffCategoryList, data);
    const matchingMcoStaffCategoryLkpcdValue = (data: any) => getMatchingLkpcd(mcoStaffCategoryList, data);
    const matchingUsaStateLkpcdValue = (data: any) => getMatchingLkpcd(usaStateList, data);

    const currentValues: Record<UserDetailKey, string> = {
        firstName: getDisplayCurrentValue("firstName"),
        middleName: getDisplayCurrentValue("middleName"),
        lastName: getDisplayCurrentValue("lastName"),
        title: getDisplayCurrentValue("title"),
        staffCategory: matchingMcoStaffCategoryLkpcd(getDisplayCurrentValue("staffCategory")),
        contactPhone: getDisplayCurrentValue("contactPhone"),
        street1: getDisplayCurrentValue("street1"),
        street2: getDisplayCurrentValue("street2"),
        street3: getDisplayCurrentValue("street3"),
        city: getDisplayCurrentValue("city"),
        state: matchingUsaStateLkpcd(getDisplayCurrentValue("state")),
        zip: getDisplayCurrentValue("zip"),
        areaCode: getDisplayCurrentValue("areaCode"),
        effectiveFromDate: getDisplayCurrentValue("effectiveFromDate"),
        effectiveToDate: getDisplayCurrentValue("effectiveToDate"),
        // changeReasonSummary: getDisplayValue("changeReasonSummary"),
    };


    const normalizeKeyCase = (obj: any): any => {
        if (Array.isArray(obj)) {
            return obj.map(item => normalizeKeyCase(item));
        }

        if (obj && typeof obj === "object") {
            const normalized: any = {};
            Object.keys(obj).forEach(key => {
                const lowerKey = key.toLowerCase();
                normalized[lowerKey] = normalizeKeyCase(obj[key]);
            });
            return normalized;
        }

        return obj;
    };

    const cleanSystemFields = (payload: any) => {
        if (!payload) return payload;

        const cloned = JSON.parse(JSON.stringify(payload));

        // Remove system fields in userDetail.after
        if (cloned.userDetail?.after) {
            delete cloned.userDetail.after.createdDate;
            delete cloned.userDetail.after.createdBy;
            delete cloned.userDetail.after.updatedDate;
            delete cloned.userDetail.after.updatedBy;
        }

        // Remove system fields for groupMemberships
        if (Array.isArray(cloned.groupMemberships)) {
            cloned.groupMemberships.forEach((item: any) => {
                if (item.after) {
                    delete item.after.createdDate;
                    delete item.after.createdBy;
                    delete item.after.updatedDate;
                    delete item.after.updatedBy;
                }

                if (item.before) {
                    delete item.before.createdDate;
                    delete item.before.createdBy;
                    delete item.before.updatedDate;
                    delete item.before.updatedBy;
                }
            });
        }

        // Same for reviewAssignments
        if (Array.isArray(cloned.reviewAssignments)) {
            cloned.reviewAssignments.forEach((item: any) => {
                if (item.after) {
                    delete item.after.createdDate;
                    delete item.after.createdBy;
                    delete item.after.updatedDate;
                    delete item.after.updatedBy;
                }

                if (item.before) {
                    delete item.before.createdDate;
                    delete item.before.createdBy;
                    delete item.before.updatedDate;
                    delete item.before.updatedBy;
                }
            });
        }

        // Same for mco authorities
        if (Array.isArray(cloned.mcoAuthorities)) {
            cloned.mcoAuthorities.forEach((item: any) => {
                if (item.after) {
                    delete item.after.createdDate;
                    delete item.after.createdBy;
                    delete item.after.updatedDate;
                    delete item.after.updatedBy;
                    delete item.after.fileLocation;
                }
                if (item.before) {
                    delete item.before.createdDate;
                    delete item.before.createdBy;
                    delete item.before.updatedDate;
                    delete item.before.updatedBy;
                    delete item.before.fileLocation;
                }
            });
        }

        return cloned;
    };

    const hasUnsavedChanges = useMemo(() => {
        const masterPayload = buildMasterPayload();
        const reviewAssignmentsPayload = buildReviewAssignmentsPayload();
        const groupMembershipPayload = buildGroupMembershipPayload();
        const mcoAuthorityPayload = buildMcoAuthorityPayload();

        const originalNotes = userChangeRequestdetails?.chngRqstNote ?? "";
        const notes = changeNotes ?? "";
        const notesChanged = notes !== originalNotes;

        const payload = {
            request: {
                userDetail: masterPayload,
                reviewAssignments: reviewAssignmentsPayload,
                groupMemberships: groupMembershipPayload,
                mcoAuthorities: mcoAuthorityPayload
            }
        };

        // Clean out fields we should ignore
        const cleanedRequest = normalizeKeyCase(cleanSystemFields(payload.request));
        const cleanedOriginal = normalizeKeyCase(cleanSystemFields(originalPayload));

        if (!originalPayload) {
            const userEditedMaster = Object.values(cleanedRequest?.userDetail?.after || {})
                .some(val => val !== null && val !== "");

            const userAddedReviewAssignments = reviewAssignmentsPayload.length > 0;
            const userAddedGroups = groupMembershipPayload.length > 0;
            const userAddedMco = mcoAuthorityPayload.length > 0;

            return (
                notesChanged ||
                userEditedMaster ||
                userAddedReviewAssignments ||
                userAddedGroups ||
                userAddedMco
            );
        }

        if (didSavedBeforeCancel) {
            return false;
        }

        return JSON.stringify(cleanedRequest) !== JSON.stringify(cleanedOriginal) || notesChanged;
    }, [currentValues]);

    const getUserGroups = async () => {
        try {
            const response = await ReportInventoryService.getMcUserGroups();
            if (response) {
                const { data } = response;
                const prefix = String(envPrefix || '').toLowerCase().trim();
                const selectedAccountType = String(
                    userChangeRequestdetails?.accountTypeLkpcd || ''
                ).trim();

                const dropdownOptions = (data || [])
                    .filter((group: any) => {
                        const display = String(group?.userGroupCode || '').toLowerCase().trim();
                        const accountTypeMatches =
                            selectedAccountType
                                ? String(group?.accountTypeLkpcd || '').trim() === selectedAccountType
                                : true;

                        return (prefix ? display.includes(prefix) : true) && accountTypeMatches;
                    })
                    .map((group: any) => ({
                        value: String(group.userGroupCode),
                        label: String(group.userGroupName),
                    }));

                setUserRoleGroupsList(dropdownOptions);
            }
        } catch (e) {
            console.log(e);
        }
    };

    const getOrganizationUnits = async () => {
        try {
            const response = await ReportInventoryService.getMcOrganizationUnits();
            if (response) {
                const { data } = response;
                const allowedCategories = new Set(['NMA', 'NMR', 'NMF']);

                const dropdownOptions = (data || [])
                    .filter((group: any) => {
                        const organizationUnitCtgryLkpcd = String(group?.organizationUnitCtgryLkpcd || '').toUpperCase().trim();
                        return allowedCategories.has(organizationUnitCtgryLkpcd);
                    })
                    .map((unit: any) => ({
                        value: String(unit.organizationUnitCode),
                        label: String(unit.organizationUnitName),
                    }));

                setOrganizationUnitsList(dropdownOptions);
            }
        } catch (e) {
            console.log(e);
        }
    };

    const getMcPlans = async () => {
        try {
            const response = await ReportInventoryService.getMcPlans();
            if (response) {
                const { data } = response;

                const dropdownOptions = (data || [])
                    .map((plan: any) => ({
                        value: String(plan.planId),
                        label: String(plan.planName),
                    }));

                setMcPlansList(dropdownOptions);
            }
        } catch (e) {
            console.log(e);
        }
    };

    const getUserdetailsByMcoStaffCtgry = async (orgUnitCd: any, mcoStaffCtgry: any, userSid: any) => {
        try {
            const response = await ReportInventoryService.getAllMcUserDetailsByMcoStaffCtgry(orgUnitCd, mcoStaffCtgry, userSid);
            if (response) {
                const { data } = response;

                const dropdownOptions = data.map((user: any) => ({
                    value: user.email,
                    label: user.email,
                    userFirstName: user.userFirstName,
                    userLastName: user.userLastName,
                    mcoStaffCtgryLkpcd: user.mcoStaffCtgryLkpcd,
                    jobTitle: user.jobTitle
                }));
                setMcoStaffUserDetailsList(dropdownOptions);
            }
        } catch (e) {
            console.log(e);
        }
    };

    const getAllMcoAuthDocsFileNames = async () => {
        try {
            const response = await ReportInventoryService.getAllMcoAuthDocsFileNames();
            if (response) {
                const { data } = response;
                setMcoAuthDocFileNames(data || []);
                return data || [];
            }
            return [];
        } catch (e) {
            console.log(e);
            return [];
        }
    };

    function toISO(dateStr: any) {
        if (!dateStr) return null;

        // Case 1: YYYY-MM-DD
        if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
            return dateStr;
        }

        // Case 2: MM/DD/YYYY → convert
        if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateStr)) {
            const [mm, dd, yyyy] = dateStr.split("/");
            return `${yyyy}-${mm}-${dd}`;
        }

        return null; // invalid format
    }

    const toDate = (str: any) => new Date(str);

    const isWithinRange = (recordFrom: any, recordTo: any, userFrom: any, userTo: any) => {
        const rf = toDate(recordFrom);
        const rt = toDate(recordTo);
        const uf = toDate(userFrom);
        const ut = toDate(userTo);

        if (Number.isNaN(rf.getTime()) || Number.isNaN(rt.getTime()) || Number.isNaN(uf.getTime()) || Number.isNaN(ut.getTime())) return false;

        return rf >= uf && rt <= ut;
    };

    const getRecEffective = (rec: any, key: string, original: any, item: any) => {
        return rec[key] ?? original[key] ?? item[key];
    };

    const isDate = (d: any) => !Number.isNaN(new Date(d).getTime());

    const validateEffectivePeriods = (payload: any) => {
        const todayCst = getTodayDate();
console.log('payload', payload);
        let userFrom = payload.request.userDetail?.after?.effectiveFromDate || payload.request.userDetail?.before?.effectiveFromDate;
        const userTo = payload.request.userDetail?.after?.effectiveToDate || payload.request.userDetail?.before?.effectiveToDate;

        // USER DETAIL effective dates validation
        if (payload.request.userDetail?.after) {
            const uf = userFrom;
            const ut = userTo;

            if (changeRequestActionType === 'A' && isDate(uf) && new Date(uf) < new Date(todayCst)) {
                return "User Detail Effective From Date cannot be less than today's date.";
            }

            if ((changeRequestActionType === 'A' || changeRequestActionType === 'M') && isDate(ut) && new Date(ut) < new Date(todayCst)) {
                return "User Detail Effective To Date cannot be less than today's date.";
            }
        }

        // REVIEW ASSIGNMENTS
        for (const ra of payload.request.reviewAssignments || []) {
            const rec = ra.after || {};
            const original = ra.before || {};

            const recFrom = getRecEffective(rec, "effectiveFromDate", original, ra);
            const recTo = getRecEffective(rec, "effectiveToDate", original, ra);
            const action = rec.proposedAction;

            if ((action === "Adding") && isDate(recFrom) && new Date(recFrom) < new Date(todayCst)) {
                return "Review Assignment Effective From Date cannot be earlier than today's date.";
            }

            if ((action === "Adding") && isDate(recTo) && new Date(recTo) < new Date(todayCst)) {
                return "Review Assignment Effective To Date cannot be earlier than today's date.";
            }

            if ((action === "Adding") && isDate(recFrom) && isDate(recTo) && new Date(recFrom) > new Date(recTo)) {
                return "Review Assignment Effective From Date cannot be greater than Effective To Date.";
            }

            if (changeRequestActionType === 'M' && userTo) {
                userFrom = payload.request.userDetail?.before?.effectiveFromDate;
            }

            if (userFrom && userTo) {
                if (!isWithinRange(recFrom, recTo, userFrom, userTo)) {
                    return "Review Assignment record is not within the user detail period. Update it first before it is saved.";
                }
            }
        }

        // GROUP MEMBERSHIPS
        for (const gm of payload.request.groupMemberships || []) {
            const rec = gm.after || {};
            const original = gm.before || {};

            const recFrom = getRecEffective(rec, "effectiveFromDate", original, gm);
            const recTo = getRecEffective(rec, "effectiveToDate", original, gm);
            let action = rec.proposedAction;

            if ((action === "Adding") && isDate(recFrom) && new Date(recFrom) < new Date(todayCst)) {
                return "User Role Group Effective From Date cannot be earlier than today's date.";
            }

            if ((action === "Adding") && isDate(recTo) && new Date(recTo) < new Date(todayCst)) {
                return "User Role Group Effective To Date cannot be earlier than today's date.";
            }

            if ((action === "Adding") && isDate(recFrom) && isDate(recTo) && new Date(recFrom) > new Date(recTo)) {
                return "User Role Group Effective From Date cannot be greater than Effective To Date.";
            }

            if (changeRequestActionType === 'M' && userTo) {
                userFrom = payload.request.userDetail?.before?.effectiveFromDate;
            }
console.log("userFrom:", userFrom, "userTo:", userTo);
            if (userFrom && userTo) {
                if (!isWithinRange(recFrom, recTo, userFrom, userTo)) {
                    return "User Role Group record is not within the user detail period. Update it first before it is saved.";
                }
            }
        }

        // MCO AUTHORITIES
        for (const mco of payload.request.mcoAuthorities || []) {
            const rec = mco.after || {};
            const original = mco.before || {};

            const recFrom = getRecEffective(rec, "effectiveFromDate", original, mco);
            const recTo = getRecEffective(rec, "effectiveToDate", original, mco);
            const action = rec.proposedAction;

            if ((action === "Adding") && isDate(recFrom) && new Date(recFrom) < new Date(todayCst)) {
                return "MCO Authority Effective From Date cannot be earlier than today's date.";
            }

            if ((action === "Adding") && isDate(recTo) && new Date(recTo) < new Date(todayCst)) {
                return "MCO Authority Effective To Date cannot be earlier than today's date.";
            }

            if ((action === "Adding") && isDate(recFrom) && isDate(recTo) && new Date(recFrom) > new Date(recTo)) {
                return "MCO Authority Effective From Date cannot be greater than Effective To Date.";
            }

            if (changeRequestActionType === 'M' && userTo) {
                userFrom = payload.request.userDetail?.before?.effectiveFromDate;
            }

            if (userFrom && userTo) {
                if (!isWithinRange(recFrom, recTo, userFrom, userTo)) {
                    return "MCO Authority record is not within the user detail period. Update it first before it is saved.";
                }
            }
        }

        return "";
    };

    const handleSavebutton = async () => {

        const addressValidationMessage = validateAddressOnSubmit(newValues);
        if (addressValidationMessage) {
            toast.warning(addressValidationMessage);
            return;
        }

        const masterPayload = buildMasterPayload();
        const reviewAssignmentsPayload = buildReviewAssignmentsPayload();
        const groupMembershipPayload = buildGroupMembershipPayload();
        const mcoAuthorityPayload = buildMcoAuthorityPayload();

        const payload = {
            updatedBy: loggedInUserDetails?.userEmail || "",
            updatedDate: getLocalIso(),
            notes: changeNotes,
            actionType: changeRequestActionType,
            request: {
                userDetail: masterPayload,
                reviewAssignments: reviewAssignmentsPayload,
                groupMemberships: groupMembershipPayload,
                mcoAuthorities: mcoAuthorityPayload
            }
        };
        if (changeRequestActionType === 'A' || changeRequestActionType === 'M') {
            const msg = validateEffectivePeriods(payload);
            if (msg) {
                toast.error(msg);
                setLoadingButton(false);
                return;
            }
        }

        if (changeRequestActionType === 'A' || changeRequestActionType === 'M') {
            const effectiveFromCst = masterPayload?.after?.effectiveFromDate;
            const todayCst = getTodayDate();

            if (effectiveFromCst < todayCst) {
                toast.error("The changes cannot be saved for new user as starting retroactively. Update all the Effective From Date to either current date or a future date before it is saved.");
                setLoadingButton(false);
                return;
            }

            const msg = validateEffectivePeriods(payload);
            if (msg) {
                toast.error(msg);
                setLoadingButton(false);
                return;
            }

            if (changeRequestActionType === 'M') {

                const isDateRangeOverlapping = (newFrom: any, newTo: any, existingFrom: any, existingTo: any) => {
                    return newFrom <= existingTo && newTo >= existingFrom;
                };

                //CHECK GROUPS OVERLAPPING
                const overlappingDuplicateExistsGroup = roleGroupChanges.some(addingRec => {

                    // We only care about records where user chose "Adding"
                    if (addingRec.proposedAction !== "Adding") return false;

                    return roleGroupChanges.some(existingRec => {

                        // Skip the same record
                        if (existingRec === addingRec) return false;

                        // Match same userGroupCode
                        if (existingRec.userGroupCode !== addingRec.userGroupCode) return false;

                        // Only consider existing records that are active or previously added
                        const isActive = (
                            existingRec.proposedAction === "Adding" ||
                            existingRec.proposedAction === "Ending" ||
                            existingRec.proposedAction === null ||
                            existingRec.proposedAction === "" ||
                            existingRec.proposedAction === undefined
                        );

                        if (!isActive) return false;

                        // Check date range overlap
                        return isDateRangeOverlapping(
                            addingRec.effectiveFromDate,
                            addingRec.effectiveToDate,
                            existingRec.effectiveFromDate,
                            existingRec.effectiveToDate
                        );
                    });
                });

                if (overlappingDuplicateExistsGroup) {
                    toast.error("An overlapping User Role Group exists.");
                    setLoadingButton(false);
                    return;
                }

                //CHECK REVIEW OVERLAPPING
                const overlappingDuplicateExistsReview = reviewAssignmentsList.some(addingRec => {

                    // Only check records marked Adding
                    if (addingRec.proposedAction !== "Adding") return false;

                    return reviewAssignmentsList.some(existingRec => {

                        // Skip same record
                        if (existingRec === addingRec) return false;

                        // Compare same Reviewer Group
                        if (existingRec.reviewerGroupCd !== addingRec.reviewerGroupCd) return false;

                        // Compare same Plan
                        if (existingRec.planId !== addingRec.planId) return false;

                        // Check overlapping date range
                        return isDateRangeOverlapping(
                            addingRec.effectiveFromDate,
                            addingRec.effectiveToDate,
                            existingRec.effectiveFromDate,
                            existingRec.effectiveToDate
                        );
                    });
                });

                if (overlappingDuplicateExistsReview) {
                    toast.error("An overlapping review assignment exists for this Reviewer Group and Plan.");
                    setLoadingButton(false);
                    return;
                }

                //CHECK MCO AUTH OVERLAPPING
                const overlappingDuplicateExistsAuth = mcoAuthorityChanges.some(addingRec => {

                    // Only check Adding records
                    if (addingRec.proposedAction !== "Adding") return false;

                    return mcoAuthorityChanges.some(existingRec => {

                        // Skip same record
                        if (existingRec === addingRec) return false;

                        // Same Email/User
                        if (existingRec.email !== addingRec.email) return false;

                        // Overlapping date ranges
                        return isDateRangeOverlapping(
                            addingRec.effectiveFromDate,
                            addingRec.effectiveToDate,
                            existingRec.effectiveFromDate,
                            existingRec.effectiveToDate
                        );
                    });
                });

                if (overlappingDuplicateExistsAuth) {
                    toast.error("An overlapping MCO Granting Authority record exists for this user.");
                    setLoadingButton(false);
                    return;
                }
            }
        }

        // setLoadingButton(true);

        console.log("Payload to save:", payload);

        const createResp = await ReportInventoryService.saveUserChangeRequestService((location?.state as any)?.chngRqstSid, payload);

        try {
            if (createResp?.status === 200) {
                toast.success('User Change Request saved successfully!');
                setOriginalMaster(userDetail);
                setOriginalReviewAssignments(reviewAssignmentsReq);
                setOriginalGroupMemberships(groupMemberships);
                // history.push({
                //     pathname: '/user-management'
                // });

            }
        } catch (error) {
            console.error('Error saving user change request:', error);
            toast.error('Failed to save user change request. Please try again.');
        } finally {
            setLoadingButton(false);
            setDidSavedBeforeCancel(true);
        }
    };

    const handleSubmitbutton = async () => {

        const addressValidationMessage = validateAddressOnSubmit(newValues);
        if (addressValidationMessage) {
            toast.warning(addressValidationMessage);
            return;
        }

        setLoadingButton(true);
        const masterPayload = buildMasterPayload();
        const reviewAssignmentsPayload = buildReviewAssignmentsPayload();
        const groupMembershipPayload = buildGroupMembershipPayload();
        const mcoAuthorityPayload = buildMcoAuthorityPayload();

        const payload = {
            updatedBy: loggedInUserDetails?.userEmail || "",
            updatedDate: getLocalIso(),
            notes: changeNotes,
            actionType: changeRequestActionType,
            request: {
                userDetail: masterPayload,
                reviewAssignments: reviewAssignmentsPayload,
                groupMemberships: groupMembershipPayload,
                mcoAuthorities: mcoAuthorityPayload
            }
        };

         if (changeRequestActionType === 'A' || changeRequestActionType === 'M') {
        
            const msg = validateEffectivePeriods(payload);
            console.log('Validation message for effective periods:', msg);
            if (msg) {
                toast.error(msg);
                setLoadingButton(false);
                return;
            }
        }
        // check groups, review assignments, and mco authorities list based on the user type
        const accountType = userChangeRequestdetails?.accountTypeLkpcd;
        const userOprtnlFlag = userChangeRequestdetails?.oprtnlUserFlag;
        const staffCategory = masterPayload?.after?.staffCategory || masterPayload?.before?.staffCategory;

        const submissionDate = new Date(getLocalIso());

        // Valid groups (EffectiveToDate >= submissionDate)
        // const validGroups = roleGroupChanges?.some(g => new Date(g.effectiveToDate) >= submissionDate);

        // Valid review groups
        // const validReviewGroups = reviewAssignmentsList?.some(g => new Date(g.effectiveToDate) >= submissionDate);

        // Valid MCO authorities
        // const validMcoAuthorities = mcoAuthorityChanges?.some(g => new Date(g.effectiveToDate) >= submissionDate);

        const today = new Date(getLocalIso().split("T")[0] + "T00:00:00");

        // Build remaining window
        const windowStart = new Date(
            Math.max(
                new Date((masterPayload?.after?.effectiveFromDate || masterPayload?.before?.effectiveFromDate) + "T00:00:00").getTime(),
                today.getTime()
            )
        );

        const windowEnd = new Date((masterPayload?.after?.effectiveToDate || masterPayload?.before?.effectiveToDate) + "T00:00:00");

        let startMatch = false;
        let endMatch = false;
        // let overlapMatch = false;

        // New valid group rule
        roleGroupChanges?.some((g, index) => {

            const gStart = new Date(g.effectiveFromDate + "T00:00:00");
            const gEnd = new Date(g.effectiveToDate + "T00:00:00");

            // Skip groups already ended
            if (gEnd < today) {
                console.log(`Group ${index + 1} has already ended.`);
                return false;
            }

            // const overlapsWindow = gStart >= windowStart && gEnd <= windowEnd;
            // if (!overlapsWindow) {
            //     return false;
            // }

            const alignsWithUserStart = windowStart <= gEnd && windowStart >= gStart;
            const alignsWithUserEnd = windowEnd <= gEnd && windowEnd <= gEnd;

            // const alignsWithUserEnd = gEnd.getTime() === windowEnd.getTime();
            // const alignsWithUserEnd = gEnd <= windowEnd && gEnd >= windowStart;

            console.log(`gstart:`, gStart);
            console.log(`gend:`, gEnd);
            console.log(`overlaps window:`, windowStart, windowEnd);

            // if (overlapsWindow) overlapMatch = true;
            if (alignsWithUserStart) startMatch = true;
            if (alignsWithUserEnd) endMatch = true;

            return false;
        });

        // FINAL evaluation after scanning ALL groups
        const finalValidGroups =  startMatch && endMatch;

        console.log("Final Start Match:", startMatch);
        console.log("Final End Match:", endMatch);
        console.log("Valid Groups:", finalValidGroups);


        // ---------------- REVIEW GROUP CHECK ----------------
        let reviewStartMatch = false;
        let reviewEndMatch = false;
        // let reviewOverlapMatch = false;

        reviewAssignmentsList?.some((g, index) => {

            const gStart = new Date(g.effectiveFromDate + "T00:00:00");
            const gEnd = new Date(g.effectiveToDate + "T00:00:00");

            if (gEnd < today) return false;

            // const overlapsWindow = gStart <= windowEnd && gEnd >= windowStart;
            const alignsWithUserStart = windowStart <= gEnd && windowStart >= gStart;
            const alignsWithUserEnd = windowEnd <= gEnd && windowEnd <= gEnd;
            // const alignsWithUserEnd = gEnd <= windowEnd && gEnd >= windowStart;

            // if (overlapsWindow) reviewOverlapMatch = true;
            if (alignsWithUserStart) reviewStartMatch = true;
            if (alignsWithUserEnd) reviewEndMatch = true;

            return false;
        });

        const finalValidReviewGroups =
             reviewStartMatch && reviewEndMatch;

        // console.log("Review Overlap:", reviewOverlapMatch);
        console.log("Review Start Match:", reviewStartMatch);
        console.log("Review End Match:", reviewEndMatch);
        console.log("Valid Review Groups:", finalValidReviewGroups);


        // ---------------- MCO AUTHORITY CHECK ----------------
        let mcoStartMatch = false;
        let mcoEndMatch = false;
        // let mcoOverlapMatch = false;

        mcoAuthorityChanges?.some((g, index) => {

            const gStart = new Date(g.effectiveFromDate + "T00:00:00");
            const gEnd = new Date(g.effectiveToDate + "T00:00:00");

            if (gEnd < today) return false;

            // const overlapsWindow = gStart <= windowEnd && gEnd >= windowStart;
            const alignsWithUserStart = windowStart <= gEnd && windowStart >= gStart;
            const alignsWithUserEnd = windowEnd <= gEnd && windowEnd <= gEnd;
            // const alignsWithUserEnd = gEnd <= windowEnd && gEnd >= windowStart;

            // if (overlapsWindow) mcoOverlapMatch = true;
            if (alignsWithUserStart) mcoStartMatch = true;
            if (alignsWithUserEnd) mcoEndMatch = true;

            return false;
        });

        const finalValidMcoAuthorities =
             mcoStartMatch && mcoEndMatch;

        // console.log("MCO Overlap:", mcoOverlapMatch);
        console.log("MCO Start Match:", mcoStartMatch);
        console.log("MCO End Match:", mcoEndMatch);
        console.log("Valid MCO Authorities:", finalValidMcoAuthorities);

        // Reviewer role present?
        const hasReviewerRole = roleGroupChanges?.some(g => g?.userGroupCode?.toUpperCase().includes("REVIEWER"));
        console.log("Has Reviewer Role:", hasReviewerRole);

        // Submitter role present?
        const hasSubmitterRole = roleGroupChanges?.some(g => g?.userGroupCode?.toUpperCase().includes("SUBMITTER"));
        console.log("Has Submitter Role:", hasSubmitterRole);

        if (userOprtnlFlag === "Y" && changeRequestActionType !== "L" && changeRequestActionType !== 'U') {

            // Require at least one group
            if (!finalValidGroups) {
                toast.error("This user must be assigned at least one Role/Group");
                setLoadingButton(false);
                return;
            }

            // Reviewer rules
            if (accountType === "S" && hasReviewerRole) {
                // if (!finalValidReviewGroups) {
                if (!reviewAssignmentsList || reviewAssignmentsList.length === 0) {
                    toast.error("This user must be assigned at least one Review Group for a Plan");
                    setLoadingButton(false);
                    return;
                }
            }

            // Submitter rules
            if (accountType === "T" && hasSubmitterRole && staffCategory !== "TM") {
                if (!finalValidMcoAuthorities) {
                    toast.error("This user must be assigned at least one MCO Authority");
                    setLoadingButton(false);
                    return;
                }
            }
        }

        if (changeRequestActionType === 'A' || changeRequestActionType === 'M') {
            const effectiveFromCst = masterPayload?.after?.effectiveFromDate;
            const todayCst = getTodayDate();

            if (effectiveFromCst < todayCst) {
                toast.error("The changes cannot be saved for new user as starting retroactively. Update all the Effective From Date to either current date or a future date before it is saved.");
                setLoadingButton(false);
                return;
            }

            // const msg = validateEffectivePeriods(payload);
            // if (msg) {
            //     toast.error(msg);
            //     setLoadingButton(false);
            //     return;
            // }

            if (changeRequestActionType === 'M') {

                const isDateRangeOverlapping = (newFrom: any, newTo: any, existingFrom: any, existingTo: any) => {
                    return newFrom <= existingTo && newTo >= existingFrom;
                };

                //CHECK GROUPS OVERLAPPING
                const overlappingDuplicateExistsGroup = roleGroupChanges.some(addingRec => {

                    // We only care about records where user chose "Adding"
                    if (addingRec.proposedAction !== "Adding") return false;

                    return roleGroupChanges.some(existingRec => {

                        // Skip the same record
                        if (existingRec === addingRec) return false;

                        // Match same userGroupCode
                        if (existingRec.userGroupCode !== addingRec.userGroupCode) return false;

                        // Only consider existing records that are active or previously added
                        const isActive = (
                            existingRec.proposedAction === "Adding" ||
                            existingRec.proposedAction === "Ending" ||
                            existingRec.proposedAction === null ||
                            existingRec.proposedAction === "" ||
                            existingRec.proposedAction === undefined
                        );

                        if (!isActive) return false;

                        // Check date range overlap
                        return isDateRangeOverlapping(
                            addingRec.effectiveFromDate,
                            addingRec.effectiveToDate,
                            existingRec.effectiveFromDate,
                            existingRec.effectiveToDate
                        );
                    });
                });

                if (overlappingDuplicateExistsGroup) {
                    toast.error("An overlapping User Role Group exists.");
                    setLoadingButton(false);
                    return;
                }

                //CHECK REVIEW OVERLAPPING
                const overlappingDuplicateExistsReview = reviewAssignmentsList.some(addingRec => {

                    // Only check records marked Adding
                    if (addingRec.proposedAction !== "Adding") return false;

                    return reviewAssignmentsList.some(existingRec => {

                        // Skip same record
                        if (existingRec === addingRec) return false;

                        // Compare same Reviewer Group
                        if (existingRec.reviewerGroupCd !== addingRec.reviewerGroupCd) return false;

                        // Compare same Plan
                        if (existingRec.planId !== addingRec.planId) return false;

                        // Check overlapping date range
                        return isDateRangeOverlapping(
                            addingRec.effectiveFromDate,
                            addingRec.effectiveToDate,
                            existingRec.effectiveFromDate,
                            existingRec.effectiveToDate
                        );
                    });
                });

                if (overlappingDuplicateExistsReview) {
                    toast.error("An overlapping review assignment exists for this Reviewer Group and Plan.");
                    setLoadingButton(false);
                    return;
                }

                //CHECK MCO AUTH OVERLAPPING
                const overlappingDuplicateExistsAuth = mcoAuthorityChanges.some(addingRec => {

                    // Only check Adding records
                    if (addingRec.proposedAction !== "Adding") return false;

                    return mcoAuthorityChanges.some(existingRec => {

                        // Skip same record
                        if (existingRec === addingRec) return false;

                        // Same Email/User
                        if (existingRec.email !== addingRec.email) return false;

                        // Overlapping date ranges
                        return isDateRangeOverlapping(
                            addingRec.effectiveFromDate,
                            addingRec.effectiveToDate,
                            existingRec.effectiveFromDate,
                            existingRec.effectiveToDate
                        );
                    });
                });

                if (overlappingDuplicateExistsAuth) {
                    toast.error("An overlapping MCO Granting Authority record exists for this user.");
                    setLoadingButton(false);
                    return;
                }
            }
        }

        const apiFileNames = await getAllMcoAuthDocsFileNames();

        // Get only "Adding" records
        const addingFiles = mcoAuthorityChanges
            .filter(x => x.proposedAction === "Adding")
            .map(x => x.documentation);

        // Compare against API response list
        const duplicates = addingFiles.filter(name =>
            apiFileNames.includes(name)
        );

        if (duplicates.length > 0) {
            toast.error(duplicates.join(", ") + " granting authority document used already for another authority for this or another user. Please upload correct document before proceeding.");
            setLoadingButton(false);
            return;
        }

        console.log("Payload to submit:", payload);
        const createResp = await ReportInventoryService.submitUserChangeRequestService((location?.state as any)?.chngRqstSid, payload);
        try {
            if (createResp?.status === 200) {
                toast.success('User Change Request submitted successfully!');
                setOriginalMaster(userDetail);
                setOriginalReviewAssignments(reviewAssignmentsReq);
                setOriginalGroupMemberships(groupMemberships);
                history.push({
                    pathname: '/user-management'
                });
            } else {
                toast.error('Failed to submit user change request. Please try again.');
            }
        } catch (error) {
            console.error('Error submitting user change request:', error);
            toast.error('Failed to submit user change request. Please try again.');
        } finally {
            setLoadingButton(false);
        }
    };

    const handleDiscardButton = async () => {
        const proceed = await confirmYesNo(`Are you sure you don't want to continue working on this change request?`);
        if (!proceed) return;

        const payload = {
            updatedBy: loggedInUserDetails?.userEmail || "",
            updatedDate: getLocalIso(),
            notes: changeNotes,
            actionType: 'D',
        };

        const createResp = await ReportInventoryService.saveUserChangeRequestService((location?.state as any)?.chngRqstSid, payload);

        try {
            if (createResp?.status === 200) {
                toast.success('User successfully discarded Change Request!');
                history.push({
                    pathname: '/user-management'
                });
            }
        } catch (error) {
            console.error('Error discarding user change request:', error);
            toast.error('Failed to discard user change request. Please try again.');
        } finally {
            setLoadingButton(false);
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                setIsLoading(true);
                await fetchGetMasterTableLookupValueData();
                // await getUserGroups();
                await getOrganizationUnits();
                await getMcPlans();

                const chngRqstSid = (location?.state as any)?.chngRqstSid || null;
                const chngRqstActionType = (location?.state as any)?.actionType || null;
                if (chngRqstSid) {
                    await getChangerequestUserDetails(chngRqstSid);
                }

                if (chngRqstActionType) {
                    setChangeRequestActionType(chngRqstActionType);
                }

            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, []);

    useEffect(() => {
        const fetchUserDetails = async () => {
            if (userChangeRequestdetails?.chngRqstNote) {
                setChangeNotes(userChangeRequestdetails.chngRqstNote);
            }

            const userSidValue = userChangeRequestdetails?.userSid || 0;

            if (userChangeRequestdetails?.organizationUnitCode) {
                if (newValues.staffCategory === 'DA') {
                    await getUserdetailsByMcoStaffCtgry(userChangeRequestdetails?.organizationUnitCode, 'TM', userSidValue);
                } else if (newValues.staffCategory === 'SS') {
                    await getUserdetailsByMcoStaffCtgry(userChangeRequestdetails?.organizationUnitCode, 'NON_SS', userSidValue);
                } else if (newValues.staffCategory === 'TM') {
                    await getUserdetailsByMcoStaffCtgry(userChangeRequestdetails?.organizationUnitCode, 'TM', userSidValue);
                } else {
                    await getUserdetailsByMcoStaffCtgry(userChangeRequestdetails?.organizationUnitCode, 'SS', userSidValue);
                }
            }

            await getUserGroups();
        };

        fetchUserDetails();
    }, [userChangeRequestdetails]);

    useEffect(() => {
        const fetchUserDetails = async () => {
            const userSidValue = userChangeRequestdetails?.userSid || 0;

            if (isNewMcoAuthorityModalOpen === true && userChangeRequestdetails?.organizationUnitCode) {
                if (changeRequestActionType === 'M') {
                    const currentStaffCategory = matchingMcoStaffCategoryLkpcdValue(currentValues.staffCategory);
                    const newStaffCategory = newValues.staffCategory;

                    if (newStaffCategory) {
                        if (newStaffCategory === 'DA') {
                            await getUserdetailsByMcoStaffCtgry(userChangeRequestdetails?.organizationUnitCode, 'TM', userSidValue);
                        } else if (newStaffCategory === 'SS') {
                            await getUserdetailsByMcoStaffCtgry(userChangeRequestdetails?.organizationUnitCode, 'NON_SS', userSidValue);
                        } else if (newStaffCategory === 'TM') {
                            setMcoAuthTmErrorMessage("Top management users do not require other authorization.");
                        } else {
                            await getUserdetailsByMcoStaffCtgry(userChangeRequestdetails?.organizationUnitCode, 'NON_SS', userSidValue);
                        }
                    } else {
                        if (currentStaffCategory === 'DA') {
                            await getUserdetailsByMcoStaffCtgry(userChangeRequestdetails?.organizationUnitCode, 'TM', userSidValue);
                        } else if (currentStaffCategory === 'SS') {
                            await getUserdetailsByMcoStaffCtgry(userChangeRequestdetails?.organizationUnitCode, 'NON_SS', userSidValue);
                        } else if (currentStaffCategory === 'TM') {
                            setMcoAuthTmErrorMessage("Top management users do not require other authorization.");
                        } else {
                            await getUserdetailsByMcoStaffCtgry(userChangeRequestdetails?.organizationUnitCode, 'NON_SS', userSidValue);
                        }
                    }
                } else if (newValues.staffCategory === 'DA') {
                    await getUserdetailsByMcoStaffCtgry(userChangeRequestdetails?.organizationUnitCode, 'TM', userSidValue);
                } else if (newValues.staffCategory === 'SS') {
                    await getUserdetailsByMcoStaffCtgry(userChangeRequestdetails?.organizationUnitCode, 'NON_SS', userSidValue);
                } else if (newValues.staffCategory === 'TM') {
                    setMcoAuthTmErrorMessage("Top management users do not require other authorization.");
                } else {
                    await getUserdetailsByMcoStaffCtgry(userChangeRequestdetails?.organizationUnitCode, 'NON_SS', userSidValue);
                }

                await getAllMcoAuthDocsFileNames();
            }
        };

        fetchUserDetails();
    }, [isNewMcoAuthorityModalOpen]);


    function safeDecodeBase64(value: string | null | undefined) {
        if (!value || value.trim() === "") return null;

        try {
            // Try decoding
            return atob(value);
        } catch (e) {
            // If the value is NOT valid base64 → return it as-is
            return value;
        }
    }

    useEffect(() => {
        const shouldPopulateNewValues = changeRequestActionType === 'A' || changeRequestActionType === 'M';

        if (shouldPopulateNewValues) {
            setNewValues({
                firstName: getDisplayNewValue("firstName") || '',
                middleName: getDisplayNewValue("middleName") || '',
                lastName: getDisplayNewValue("lastName") || '',
                title: getDisplayNewValue("title") || '',
                staffCategory: getDisplayNewValue("staffCategory") || '',
                contactPhone: getDisplayNewValue("contactPhone") || '',
                street1: getDisplayNewValue("street1") || '',
                street2: getDisplayNewValue("street2") || '',
                street3: getDisplayNewValue("street3") || '',
                city: getDisplayNewValue("city") || '',
                state: normalizeStateValue(getDisplayNewValue("state")) || '',
                zip: getDisplayNewValue("zip") || '',
                areaCode: getDisplayNewValue("areaCode") || '',
                effectiveFromDate:
                    changeRequestActionType === 'M'
                        ? currentValues.effectiveFromDate
                        : getDisplayNewValue("effectiveFromDate") || getTodayDate(),
                effectiveToDate: getDisplayNewValue("effectiveToDate") || DEFAULT_TO_DATE || ''
            });
        }

        const savedRoles = getSavedRolesNewValue() || [];
        const savedReviewAssignments = getSavedeviewAssignmentsNewValue() || [];
        const savedMcoAuthorities = (getSavedMcoAuthorityNewValue() || []).map((item: any) => ({
            ...item,
            name: [item.lastName, item.firstName].filter(Boolean).join(', '),
            fileLocation: safeDecodeBase64(item.fileLocation),
        }));
        setReviewAssignmentsList(savedReviewAssignments);
        setRoleGroupChanges(savedRoles);
        setMcoAuthorityChanges(savedMcoAuthorities);
    }, [parsedPayload, changeRequestActionType, usaStateList]);


    useEffect(() => {
        if (changeRequestActionType === 'L' || changeRequestActionType === 'U') return;

        const payloadState = getDisplayNewValue("state");
        if (!payloadState && !isAnyAddressFieldFilled(newValues)) {
            if (newValues.state !== '') {
                setNewValues(prev => ({ ...prev, state: '' }));
            }
        }

    }, [parsedPayload, newValues.street1, newValues.street2, newValues.street3, newValues.city, newValues.zip]);

    useEffect(() => {
        setNewFromDate(newValues.effectiveFromDate || getTodayDate());
        setNewReviewFromDate(newValues.effectiveFromDate || getTodayDate());
        setNewMcoAuthFromDate(newValues.effectiveFromDate || getTodayDate());
    }, [newValues.effectiveFromDate]);

    return (
        <>
            <Navbar />
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>

                <div
                    style={{ alignSelf: 'flex-start' }}
                    onMouseDownCapture={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleCancel();
                    }}
                >
                    <BackButton />
                </div>

                <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                    <PageSubTitle text="User Account Change Request" />
                </div>
            </div>

            {isLoading ? (
                <div className="loading-container">
                    <div className="loading-spinner"></div>
                    <p>Loading.....</p>
                </div>
            ) :
                <>
                    <div className="form-layout" style={{ border: '1px solid #222', padding: '20px', margin: '20px', borderRadius: '2px' }}>
                        <div className="external-filters-action flex flex-row justify-end w-full md:w-auto" style={{ marginBottom: '-30px' }}>
                            <Button
                                className="OkButton"
                                onClick={() => handleSavebutton()}
                                loading={loadingButton}
                                disabled={
                                    changeRequestActionType === 'A' &&
                                    (
                                        !newValues.firstName ||
                                        !newValues.lastName ||
                                        !newValues.title ||
                                        !newValues.effectiveFromDate ||
                                        !newValues.effectiveToDate ||
                                        // !changeNotes ||
                                        (userChangeRequestdetails?.accountTypeLkpcd === 'T' && !newValues.staffCategory) ||
                                        (userChangeRequestdetails?.accountTypeLkpcd === 'T' &&
                                            newValues.staffCategory !== 'TM' &&
                                            !newValues.contactPhone)
                                    )
                                }

                            >
                                Save
                            </Button>
                            <Button
                                className="OkButton"
                                onClick={() => handleDiscardButton()}
                                loading={loadingButton}
                            >
                                Discard
                            </Button>
                            <Button
                                className="OkButton"
                                onClick={() => handleSubmitbutton()}
                                loading={loadingButton}
                                disabled={changeRequestActionType === 'A' && (!newValues.firstName || !newValues.lastName || !newValues.title || !newValues.effectiveFromDate || !newValues.effectiveToDate || !changeNotes
                                    || (userChangeRequestdetails?.accountTypeLkpcd === 'T' && !newValues.staffCategory)
                                    || (userChangeRequestdetails?.accountTypeLkpcd === 'T' && newValues.staffCategory != 'TM' && !newValues.contactPhone)
                                ) || !changeNotes
                                }
                            >
                                Submit
                            </Button>
                            <Button
                                className="OkButton"
                                onClick={() => handleCancel()}
                            >
                                Cancel
                            </Button>
                        </div>
                        <div className="details-block">
                            <div className="row1" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div className="element" style={{ flex: 1, marginRight: '10px' }}>
                                    <InputText
                                        context="registration"
                                        label="Organization"
                                        name="organizationUnitCode"
                                        placeholder="Organization"
                                        value={userChangeRequestdetails?.organizationUnitCode || ''}
                                        disabled={true}
                                    />
                                </div>
                                <div className="element" style={{ flex: 1, marginRight: '10px' }}>
                                    <InputText
                                        context="registration"
                                        label="User/Email ID"
                                        name="userId"
                                        placeholder="User/Email ID"
                                        value={userChangeRequestdetails?.userId || ''}
                                        disabled={true}
                                    />
                                </div>
                                <div className="element" style={{ flex: 1, marginRight: '10px' }}>
                                    <InputText
                                        context="registration"
                                        label="Operational User"
                                        name="oprtnlUserFlag"
                                        placeholder="Operational User"
                                        value={userChangeRequestdetails?.oprtnlUserFlag === 'Y' ? 'Yes' : userChangeRequestdetails?.oprtnlUserFlag === 'N' ? 'No' : ''}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                            <div className="row1" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div className="element" style={{ flex: 1, marginRight: '10px' }}>
                                    <InputText
                                        context="registration"
                                        label="Account Type"
                                        name="accountTypeLkpcd"
                                        placeholder="Account Type"
                                        value={matchingAccountTypeLkpcd(userChangeRequestdetails?.accountTypeLkpcd)}
                                        disabled={true}
                                    />
                                </div>
                                <div className="element" style={{ flex: 1, marginRight: '10px' }}>
                                    <InputText
                                        context="registration"
                                        label="Request Type"
                                        name="chngRqstTypeLkpcd"
                                        placeholder="Request Type"
                                        value={matchingChangeRequestTypeLkpcd(changeRequestActionType === 'L' ? 'L' : changeRequestActionType === 'U' ? 'U' : userChangeRequestdetails?.chngRqstTypeLkpcd) || ''}
                                        disabled={true}
                                    />
                                </div>
                                <div className="element" style={{ flex: 1, marginRight: '10px' }}>
                                    <InputText
                                        context="registration"
                                        label="Request Status"
                                        name="afStatusLkpcd"
                                        placeholder="Request Status"
                                        value={matchingUserChangeRequestStatusLkpcd(userChangeRequestdetails?.afStatusLkpcd) || ''}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                            <div className="row1" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div className="element" style={{ flex: 1, marginRight: '10px' }}>
                                    <InputText
                                        context="registration"
                                        label="Initiated By"
                                        name="createdBy"
                                        placeholder="Initiated By"
                                        value={userChangeRequestdetails?.createdBy || ''}
                                        disabled={true}
                                    />
                                </div>
                                <div className="element" style={{ flex: 1, marginRight: '10px' }}>
                                    <InputText
                                        context="registration"
                                        label="Initiated Date"
                                        name="createdDate"
                                        placeholder="Initiated Date"
                                        value={formatDateForDisplay(userChangeRequestdetails?.createdDate, "MM/DD/YYYY hh:mm:ss.SSS A") || ''}
                                        disabled={true}
                                    />
                                </div>
                                <div className="element" style={{ flex: 1, marginRight: '10px' }}>
                                    {/* <InputText
                                context="registration"
                                label="r"
                                name="operationalUser"
                                placeholder="Operational User"
                                value={''}
                                disabled={true}
                            /> */}
                                </div>
                            </div>
                        </div>

                        <h3><b>User Details</b></h3>
                        <div className="details-block" style={{ marginTop: 0 }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
                                <thead>
                                    <tr style={{ backgroundColor: '#a9bfd3' }}>
                                        <th style={{ border: '1px solid #222', padding: '6px', textAlign: 'left', width: '30%' }}>Field</th>
                                        <th style={{ border: '1px solid #222', padding: '6px', textAlign: 'center', width: '35%' }}>Current Value</th>
                                        {!(changeRequestActionType === 'L' || changeRequestActionType === 'U') && (
                                            <th style={{ border: '1px solid #222', padding: '6px', textAlign: 'center', width: '35%' }}>
                                                New Value
                                            </th>
                                        )}
                                    </tr>
                                </thead>
                                <tbody>
                                    {userDetailRows.map((row) => (
                                        <tr key={row.key}>
                                            <td style={{ border: '1px solid #222', padding: '4px 6px' }}>{row.label}</td>
                                            <td style={{ border: '1px solid #222', padding: '2px 4px' }}>
                                                {row.type === "date" ? (
                                                    <span
                                                        style={{
                                                            display: 'block',
                                                            width: '100%',
                                                            padding: '4px 6px',
                                                            backgroundColor: '#e8e8e8',
                                                            fontSize: '100%',
                                                            color: '#6c6c6c',
                                                            boxSizing: 'border-box',
                                                            height: '32px',
                                                            lineHeight: '22px',
                                                            cursor: 'not-allowed'
                                                        }}
                                                    >
                                                        {formatDisplayDate(currentValues[row.key])}
                                                    </span>

                                                ) : (
                                                    <input
                                                        type={row.type || 'text'}
                                                        value={currentValues[row.key]}
                                                        readOnly
                                                        disabled
                                                        style={{ width: '100%', border: 'none', background: '#e8e8e8', padding: '4px 6px' }}
                                                    />
                                                )}
                                            </td>
                                            {!(changeRequestActionType === 'L' || changeRequestActionType === 'U') && (
                                                <td style={{ border: '1px solid #222', padding: '2px 4px' }}>
                                                    {row.mask ? (
                                                        <InputMask
                                                            mask={row.mask}
                                                            value={newValues[row.key]}
                                                            onChange={onNewValueChange(row.key)}
                                                            disabled={changeRequestActionType === 'L' || changeRequestActionType === 'U'}
                                                            style={{ width: '100%', border: 'none', background: '#fff', padding: '4px 6px' }}
                                                        />
                                                    ) : row.select ? (
                                                        <select
                                                            value={newValues[row.key]}
                                                            onChange={async (e) => {
                                                                const newVal = e.target.value;

                                                                // Special handling for Staff Category
                                                                if (row.key === 'staffCategory') {
                                                                    const prevVal = (newValues.staffCategory || currentValues.staffCategory || '');
                                                                    const oldCurrentVal = matchingMcoStaffCategoryLkpcdValue(currentValues.staffCategory || '');

                                                                    if (newVal === '') {
                                                                        setNewValues((prev) => ({ ...prev, [row.key]: '' }));
                                                                        return;
                                                                    }
                                                                    if (newVal !== oldCurrentVal && prevVal !== '') {
                                                                        const msg = "Changing the category for this user will require to setup the MCO Authority again. Do you want to continue?";
                                                                        const proceed = await confirmYesNo(msg);
                                                                        if (!proceed) {
                                                                            return;
                                                                        }
                                                                        setNewValues((prev) => ({ ...prev, [row.key]: newVal === '' ? '' : newVal }));

                                                                        if (changeRequestActionType === "M") {
                                                                            const todayCst = getTodayDate();

                                                                            setMcoAuthorityChanges(prevPayload => {
                                                                                return prevPayload.filter(rec => rec.proposedAction !== "Adding");
                                                                            });

                                                                            setMcoAuthorityChanges(prevPayload => {
                                                                                return prevPayload.map(rec => {
                                                                                    const action = rec.proposedAction || "";

                                                                                    const recDateStr = rec.effectiveToDate;

                                                                                    const recDate = recDateStr ? new Date(recDateStr) : null;
                                                                                    const today = new Date(todayCst);

                                                                                    const isPastRecord = recDate && recDate < today;
                                                                                    if (isPastRecord) {
                                                                                        return rec;
                                                                                    }

                                                                                    if (action === "" || action === "Ending") {
                                                                                        return {
                                                                                            ...rec,
                                                                                            proposedAction: "Ending",
                                                                                            effectiveToDate: todayCst
                                                                                        };
                                                                                    }

                                                                                    return rec;
                                                                                });
                                                                            });
                                                                        } else {
                                                                            setMcoAuthorityChanges([]);
                                                                            setSelectedMcoAuthorityId('');
                                                                            return;
                                                                        }
                                                                    }
                                                                }

                                                                if (row.key === 'state' && newVal === "") {
                                                                    if (isAnyAddressFieldFilled(newValues)) {
                                                                        toast.warning("Street Address 1, City, State, and Zip must all be filled.");
                                                                        return;
                                                                    }
                                                                }

                                                                setNewValues((prev) => ({
                                                                    ...prev,
                                                                    [row.key]: newVal === '' ? '' : newVal
                                                                }));
                                                            }}
                                                            style={{ width: '100%', border: 'none', background: '#fff', padding: '4px 6px' }}
                                                            disabled={changeRequestActionType === 'L' || changeRequestActionType === 'U'}
                                                        >
                                                            <option value="">{row.key === 'state' ? '-- Select State --' : '-- Select Staff Category --'}</option>
                                                            {row.select.map((s: any) => (
                                                                <option key={s.value} value={s.value}>{s.label}</option>
                                                            ))}
                                                        </select>
                                                    ) : (
                                                        <input
                                                            type={row.type || 'text'}
                                                            value={newValues[row.key]}
                                                            disabled={
                                                                changeRequestActionType === 'L' ||
                                                                changeRequestActionType === 'U' ||
                                                                (row.key === 'effectiveFromDate' && changeRequestActionType === 'M')
                                                            }
                                                            onChange={
                                                                row.key === 'effectiveFromDate' || row.key === 'effectiveToDate'
                                                                    ? handleDateChange(row.key)
                                                                    : onNewValueChange(row.key)
                                                            }
                                                            min={
                                                                row.key === 'effectiveFromDate'
                                                                    ? getTodayDate()
                                                                    : row.key === 'effectiveToDate'
                                                                        ? (newValues.effectiveFromDate || getTodayDate())
                                                                        : undefined
                                                            }
                                                            style={{ width: '100%', border: 'none', background: '#fff', padding: '4px 6px' }}
                                                        />)}
                                                </td>
                                            )}
                                        </tr>))}
                                </tbody>
                            </table>
                        </div>

                        {(userChangeRequestdetails?.accountTypeLkpcd === 'S' ||
                            (userChangeRequestdetails?.accountTypeLkpcd === 'T' && userChangeRequestdetails?.oprtnlUserFlag === 'Y')) && (
                                <>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                        <h3 style={{ margin: 0 }}><b>User Role Groups</b></h3>
                                        <div className="external-filters-action flex flex-row justify-end w-full md:w-auto" style={{ marginBottom: 0 }}>
                                            <Button className="OkButton" onClick={handleOpenNewRoleModal} disabled={changeRequestActionType === 'L' || changeRequestActionType === 'U'}>New</Button>
                                            <Button className="OkButton" onClick={handleOpenEndRoleModal} disabled={
                                                !(
                                                    changeRequestActionType === 'M' &&
                                                    selectedRoleRow &&
                                                    selectedRoleRow?.proposedAction == null
                                                )
                                            }>End</Button>
                                            <Button className="OkButton" onClick={handleUndoRoleGroupChanges} disabled={!selectedRoleRow || !roleGroupChanges.length || changeRequestActionType === 'L' || changeRequestActionType === 'U' ||
                                                selectedRoleRow?.proposedAction === null || selectedRoleRow?.proposedAction === undefined
                                            }>Undo</Button>
                                        </div>
                                    </div>
                                    <div className="details-block" style={{ marginTop: 0, marginBottom: 0 }}>
                                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                            <thead>
                                                <tr style={{ background: '#dbe3f3' }}>
                                                    <th style={{ border: '1px solid #222', width: '36px' }}></th>
                                                    <th style={{ border: '1px solid #222', textAlign: 'left', padding: '4px 6px' }}>Role</th>
                                                    <th style={{ border: '1px solid #222', textAlign: 'center', padding: '4px 6px' }}>Effective From Date</th>
                                                    <th style={{ border: '1px solid #222', textAlign: 'center', padding: '4px 6px' }}>Effective To Date</th>
                                                    <th style={{ border: '1px solid #222', textAlign: 'left', padding: '4px 6px' }}>Proposed Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {roleGroupChanges.length === 0 ? (
                                                    <tr>
                                                        <td colSpan={5} style={{ border: '1px solid #222', textAlign: 'center', padding: '8px' }}>
                                                            No pending role group changes
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    roleGroupChanges.map((row) => (
                                                        <tr key={row.id}>
                                                            <td style={{ border: '1px solid #222', textAlign: 'center' }}>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={selectedRoleId === row.userGroupCode + '-' + row.effectiveFromDate + '-' + row.effectiveToDate}
                                                                    onChange={() => handleRoleCheckboxChange(row.userGroupCode + '-' + row.effectiveFromDate + '-' + row.effectiveToDate)}
                                                                />
                                                            </td>
                                                            <td style={{ border: '1px solid #222', padding: '3px 6px' }}>{getGroupLabel(row.userGroupCode)}</td>
                                                            <td style={{ border: '1px solid #222', textAlign: 'center', padding: '3px 6px' }}>{formatDisplayDate(row.effectiveFromDate)}</td>
                                                            <td style={{ border: '1px solid #222', textAlign: 'center', padding: '3px 6px' }}>{formatDisplayDate(row.effectiveToDate)}</td>
                                                            <td style={{ border: '1px solid #222', padding: '3px 6px' }}>{row.proposedAction}</td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </>
                            )}

                        {(userChangeRequestdetails?.accountTypeLkpcd === 'S') && (
                            <>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                    <h3 style={{ margin: 0 }}><b>Review Assignments</b></h3>
                                    <div className="external-filters-action flex flex-row justify-end w-full md:w-auto" style={{ marginBottom: 0 }}>
                                        <Button className="OkButton" onClick={handleOpenNewReviewModal} disabled={changeRequestActionType === 'L' || changeRequestActionType === 'U'}>New</Button>
                                        <Button className="OkButton" onClick={handleOpenEndReviewModal} disabled={
                                            !(
                                                changeRequestActionType === 'M' &&
                                                selectedReviewRow &&
                                                selectedReviewRow?.proposedAction == null
                                            )
                                        } >End</Button>
                                        <Button className="OkButton" onClick={handleUndoReviewAssignments} disabled={!selectedReviewRow || !reviewAssignmentsList.length || changeRequestActionType === 'L' || changeRequestActionType === 'U'
                                            || selectedReviewRow?.proposedAction === null || selectedReviewRow?.proposedAction === undefined
                                        }>Undo</Button>
                                    </div>
                                </div>
                                <div className="details-block" style={{ marginTop: 0, marginBottom: 0 }}>
                                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                        <thead>
                                            <tr style={{ background: '#dbe3f3' }}>
                                                <th style={{ border: '1px solid #222', width: '36px' }}></th>
                                                <th style={{ border: '1px solid #222', textAlign: 'left', padding: '4px 6px' }}>Reviewer Group</th>
                                                <th style={{ border: '1px solid #222', textAlign: 'left', padding: '4px 6px' }}>Plan</th>
                                                <th style={{ border: '1px solid #222', textAlign: 'center', padding: '4px 6px' }}>Effective From Date</th>
                                                <th style={{ border: '1px solid #222', textAlign: 'center', padding: '4px 6px' }}>Effective To Date</th>
                                                <th style={{ border: '1px solid #222', textAlign: 'left', padding: '4px 6px' }}>Proposed Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {reviewAssignmentsList.length === 0 ? (
                                                <tr>
                                                    <td colSpan={6} style={{ border: '1px solid #222', textAlign: 'center', padding: '8px' }}>
                                                        No pending review assignment changes
                                                    </td>
                                                </tr>
                                            ) : (
                                                reviewAssignmentsList.map((row) => (
                                                    <tr key={row.id}>
                                                        <td style={{ border: '1px solid #222', textAlign: 'center' }}>
                                                            <input
                                                                type="checkbox"
                                                                checked={selectedReviewId === row.reviewerGroupCd + '-' + row.planId + '-' + row.id}
                                                                onChange={() => handleReviewCheckboxChange(row.reviewerGroupCd + '-' + row.planId + '-' + row.id)}
                                                            />
                                                        </td>
                                                        <td style={{ border: '1px solid #222', padding: '3px 6px' }}>{getReviewGroupLabel(row.reviewerGroupCd)}</td>
                                                        <td style={{ border: '1px solid #222', padding: '3px 6px' }}>{getPlanLabel(row.planId)}</td>
                                                        <td style={{ border: '1px solid #222', textAlign: 'center', padding: '3px 6px' }}>{formatDisplayDate(row.effectiveFromDate)}</td>
                                                        <td style={{ border: '1px solid #222', textAlign: 'center', padding: '3px 6px' }}>{formatDisplayDate(row.effectiveToDate)}</td>
                                                        <td style={{ border: '1px solid #222', padding: '3px 6px' }}>{row.proposedAction}</td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </>
                        )}

                        {(userChangeRequestdetails?.accountTypeLkpcd === 'T' && userChangeRequestdetails?.oprtnlUserFlag === 'Y') && (
                            <>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                    <h3 style={{ margin: 0 }}><b>MCO Granting Authority</b></h3>
                                    <div className="external-filters-action flex flex-row justify-end w-full md:w-auto" style={{ marginBottom: 0 }}>
                                        <Button className="OkButton" onClick={handleOpenNewMcoAuthorityModal} disabled={changeRequestActionType === 'L' || changeRequestActionType === 'U'}>New</Button>
                                        <Button className="OkButton" onClick={handleOpenEndMcoAuthorityModal} disabled={
                                            !(
                                                changeRequestActionType === 'M' &&
                                                selectedMcoAuthorityRow &&
                                                selectedMcoAuthorityRow?.proposedAction == null
                                            )
                                        }>End</Button>
                                        <Button className="OkButton" onClick={handleUndoMcoAuthorityChanges} disabled={!selectedMcoAuthorityRow || !mcoAuthorityChanges.length || changeRequestActionType === 'L' || changeRequestActionType === 'U'
                                            || selectedMcoAuthorityRow?.proposedAction === null || selectedMcoAuthorityRow?.proposedAction === undefined
                                        }>Undo</Button>
                                    </div>
                                </div>
                                <div className="details-block" style={{ marginTop: 0, marginBottom: 0 }}>
                                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                        <thead>
                                            <tr style={{ background: '#dbe3f3' }}>
                                                <th style={{ border: '1px solid #222', width: '36px' }}></th>
                                                <th style={{ border: '1px solid #222', textAlign: 'left', padding: '4px 6px' }}>Name</th>
                                                <th style={{ border: '1px solid #222', textAlign: 'left', padding: '4px 6px' }}>Title</th>
                                                <th style={{ border: '1px solid #222', textAlign: 'left', padding: '4px 6px' }}>Documentation</th>
                                                <th style={{ border: '1px solid #222', textAlign: 'center', padding: '4px 6px' }}>Effective From Date</th>
                                                <th style={{ border: '1px solid #222', textAlign: 'center', padding: '4px 6px' }}>Effective To Date</th>
                                                <th style={{ border: '1px solid #222', textAlign: 'left', padding: '4px 6px' }}>Proposed Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {mcoAuthorityChanges.length === 0 ? (
                                                <tr>
                                                    <td colSpan={7} style={{ border: '1px solid #222', textAlign: 'center', padding: '8px' }}>
                                                        No pending MCO authority changes
                                                    </td>
                                                </tr>
                                            ) : (
                                                mcoAuthorityChanges.map((row) => (
                                                    <tr key={row.id}>
                                                        <td style={{ border: '1px solid #222', textAlign: 'center' }}>
                                                            <input
                                                                type="checkbox"
                                                                checked={selectedMcoAuthorityId === row.id + '-' + row.effectiveFromDate + '-' + row.effectiveToDate}
                                                                onChange={() => handleMcoAuthCheckboxChange(row.id + '-' + row.effectiveFromDate + '-' + row.effectiveToDate)}
                                                            />
                                                        </td>
                                                        <td style={{ border: '1px solid #222', padding: '3px 6px' }}>{row.name}</td>
                                                        <td style={{ border: '1px solid #222', padding: '3px 6px' }}>{row.title}</td>
                                                        <td style={{ border: '1px solid #222', padding: '3px 6px' }}>{row.documentation}</td>
                                                        <td style={{ border: '1px solid #222', textAlign: 'center', padding: '3px 6px' }}>{formatDisplayDate(row.effectiveFromDate)}</td>
                                                        <td style={{ border: '1px solid #222', textAlign: 'center', padding: '3px 6px' }}>{formatDisplayDate(row.effectiveToDate)}</td>
                                                        <td style={{ border: '1px solid #222', padding: '3px 6px' }}>{row.proposedAction}</td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </>
                        )}

                        <div className="details-block">
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                <h3 style={{ margin: 0 }}><b>Change Reason Narrative*</b></h3>
                            </div>
                            <div className="details-block" style={{ marginTop: 0, marginBottom: 0 }}>
                                <textarea
                                    value={changeNotes}
                                    onChange={(e) => handleChangeNotes(e)}
                                    placeholder="Enter change reason "
                                    rows={4}
                                    maxLength={1000}
                                    style={{
                                        width: '100%',
                                        border: '1px solid #222',
                                        padding: '8px',
                                        resize: 'vertical',
                                        boxSizing: 'border-box'
                                    }}
                                />
                            </div>
                        </div>

                        <div className="row1">
                            <div className="element" >
                                <p>
                                    <b>Last Updated By : </b>{userChangeRequestdetails?.updatedBy || ''}
                                </p>
                            </div>
                            <div className="element" >
                                <p><b>Last Updated Date : </b>{formatDateForDisplay(userChangeRequestdetails?.updatedDate, "MM/DD/YYYY hh:mm:ss.SSS A") || ''}</p>
                            </div>
                        </div>

                        <div className="external-filters-action flex flex-row justify-end w-full md:w-auto" style={{ marginBottom: '-30px' }}>
                            <Button
                                className="OkButton"
                                onClick={() => handleSavebutton()}
                                loading={loadingButton}
                                disabled={changeRequestActionType === 'A' && (!newValues.firstName || !newValues.lastName || !newValues.title || !newValues.effectiveFromDate || !newValues.effectiveToDate
                                    // || !changeNotes
                                    || (userChangeRequestdetails?.accountTypeLkpcd === 'T' && !newValues.staffCategory)
                                    || (userChangeRequestdetails?.accountTypeLkpcd === 'T' && newValues.staffCategory != 'TM' && !newValues.contactPhone)
                                )
                                }
                            >
                                Save
                            </Button>
                            <Button
                                className="OkButton"
                                onClick={() => handleDiscardButton()}
                                loading={loadingButton}
                            >
                                Discard
                            </Button>
                            <Button
                                className="OkButton"
                                onClick={() => handleSubmitbutton()}
                                loading={loadingButton}
                                disabled={changeRequestActionType === 'A' && (!newValues.firstName || !newValues.lastName || !newValues.title || !newValues.effectiveFromDate || !newValues.effectiveToDate || !changeNotes
                                    || (userChangeRequestdetails?.accountTypeLkpcd === 'T' && !newValues.staffCategory)
                                    || (userChangeRequestdetails?.accountTypeLkpcd === 'T' && newValues.staffCategory != 'TM' && !newValues.contactPhone)
                                ) || !changeNotes
                                }
                            >
                                Submit
                            </Button>
                            <Button
                                className="OkButton"
                                onClick={() => handleCancel()}
                            >
                                Cancel
                            </Button>
                        </div>
                    </div>

                    <Modal
                        isOpen={isNewRoleModalOpen}
                        onRequestClose={() => setIsNewRoleModalOpen(false)}
                        shouldCloseOnOverlayClick={false}
                        contentLabel="Add User Role Group"
                        style={{ content: { width: '600px', height: '360px', margin: 'auto', border: '2px solid #222' } }}
                    >
                        <h2 style={{ textAlign: 'center', marginBottom: '16px' }}><b>Add User Role/Group</b></h2>
                        <div style={{ width: '80%', margin: '0 auto', display: 'grid', gap: '14px' }}>
                            <MultiSelectDropdown
                                options={userRoleGroupsList}
                                selectedValues={newRoles}
                                onChange={setNewRoles}
                                label="Role/Group"
                                mandatoryLabel={true}
                            />
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', alignItems: 'center' }}>
                                <label><b>Effective From Date*</b></label>
                                <input
                                    type="date"
                                    value={newFromDate}
                                    onChange={handleRoleFromDateChange}
                                    min={getTodayDate()}
                                    style={dateInputStyle}
                                // onKeyDown={(e) => e.preventDefault()}
                                // onPaste={(e) => e.preventDefault()}
                                // onClick={(e) => {
                                //     const input = e.target as HTMLInputElement;
                                //     if (input.showPicker) {
                                //         input.showPicker();
                                //     }
                                // }}
                                />
                            </div>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', alignItems: 'center' }}>
                                <label><b>Effective To Date*</b></label>
                                <input
                                    type="date"
                                    value={newToDate}
                                    onChange={handleRoleToDateChange}
                                    min={newFromDate || getTodayDate()}
                                    style={dateInputStyle}
                                // onKeyDown={(e) => e.preventDefault()}
                                // onPaste={(e) => e.preventDefault()}
                                // onClick={(e) => {
                                //     const input = e.target as HTMLInputElement;
                                //     if (input.showPicker) {
                                //         input.showPicker();
                                //     }
                                // }}
                                />
                            </div>
                            <div style={{ marginTop: '18px', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                                <Button className="OkButton" onClick={handleConfirmNewRole} disabled={!newRoles.length || !newFromDate || !newToDate}>Confirm</Button>
                                <Button className="OkButton" onClick={() => setIsNewRoleModalOpen(false)}>Cancel</Button>
                            </div>
                        </div>
                    </Modal>

                    <Modal
                        isOpen={isEndRoleModalOpen}
                        onRequestClose={() => setIsEndRoleModalOpen(false)}
                        shouldCloseOnOverlayClick={false}
                        contentLabel="End User Role Group"
                        style={{ content: { width: '600px', height: '300px', margin: 'auto', border: '2px solid #222' } }}
                    >
                        <h2 style={{ textAlign: 'center', marginBottom: '16px' }}><b>End User Role/Group</b></h2>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', alignItems: 'center' }}>
                            <label><b>Role/Group*</b></label>
                            <input type="text" value={endRole} readOnly disabled style={dateInputStyle} />
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', alignItems: 'center', marginTop: '10px' }}>
                            <label><b>Effective From Date*</b></label>
                            <input type="date" value={endFromDate} readOnly disabled style={dateInputStyle} />
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', alignItems: 'center', marginTop: '10px' }}>
                            <label><b>Current Effective To Date*</b></label>
                            <input type="date" value={currentEndToDate} readOnly disabled style={dateInputStyle} />
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', alignItems: 'center', marginTop: '10px' }}>
                            <label><b>Revised Effective To Date*</b></label>
                            <input type="date"
                                value={revisedEndToDate}
                                onChange={handleRevisedEndRoleDateChange}
                                style={dateInputStyle} />
                        </div>
                        <div style={{ marginTop: '18px', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                            <Button className="OkButton" onClick={handleSaveEndRole}>Confirm</Button>
                            <Button className="OkButton" onClick={() => setIsEndRoleModalOpen(false)}>Cancel</Button>
                        </div>
                    </Modal>

                    <Modal
                        isOpen={isNewReviewModalOpen}
                        onRequestClose={() => setIsNewReviewModalOpen(false)}
                        shouldCloseOnOverlayClick={false}
                        contentLabel="Add Review Assignment"
                        style={{ content: { width: '600px', height: '450px', margin: 'auto', border: '2px solid #222' } }}
                    >
                        <h2 style={{ textAlign: 'center', marginBottom: '16px' }}><b>Add Review Assignment</b></h2>
                        <div style={{ width: '80%', margin: '0 auto', display: 'grid', gap: '14px' }}>
                            <MultiSelectDropdown
                                options={organizationUnitsList}
                                selectedValues={newReviewerGroups}
                                onChange={setNewReviewerGroups}
                                label="Reviewer Group"
                                mandatoryLabel={true}
                            />
                            <MultiSelectDropdown
                                options={mcPlansList}
                                selectedValues={newReviewPlans}
                                onChange={setNewReviewPlans}
                                label="Plan"
                                mandatoryLabel={true}
                            />
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', alignItems: 'center' }}>
                                <label><b>Effective From Date*</b></label>
                                <input
                                    type="date"
                                    value={newReviewFromDate}
                                    onChange={handleReviewFromDateChange}
                                    min={getTodayDate()}
                                    style={dateInputStyle}
                                // onKeyDown={(e) => e.preventDefault()}
                                // onPaste={(e) => e.preventDefault()}
                                // onClick={(e) => {
                                //     const input = e.target as HTMLInputElement;
                                //     if (input.showPicker) {
                                //         input.showPicker();
                                //     }
                                // }}
                                />
                            </div>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', alignItems: 'center' }}>
                                <label><b>Effective To Date*</b></label>
                                <input
                                    type="date"
                                    value={newReviewToDate}
                                    onChange={handleReviewToDateChange}
                                    min={newReviewFromDate || getTodayDate()}
                                    style={dateInputStyle}
                                // onKeyDown={(e) => e.preventDefault()}
                                // onPaste={(e) => e.preventDefault()}
                                // onClick={(e) => {
                                //     const input = e.target as HTMLInputElement;
                                //     if (input.showPicker) {
                                //         input.showPicker();
                                //     }
                                // }}
                                />
                            </div>
                            <div style={{ marginTop: '18px', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                                <Button className="OkButton" onClick={handleSaveNewReview} disabled={!newReviewerGroups.length || !newReviewPlans.length || !newReviewFromDate || !newReviewToDate}>Confirm</Button>
                                <Button className="OkButton" onClick={() => setIsNewReviewModalOpen(false)}>Cancel</Button>
                            </div>
                        </div>
                    </Modal>

                    <Modal
                        isOpen={isEndReviewModalOpen}
                        onRequestClose={() => setIsEndReviewModalOpen(false)}
                        shouldCloseOnOverlayClick={false}
                        contentLabel="End Review Assignment"
                        style={{ content: { width: '600px', height: '360px', margin: 'auto', border: '2px solid #222' } }}
                    >
                        <h2 style={{ textAlign: 'center', marginBottom: '16px' }}><b>End Reviewer Assignment</b></h2>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', alignItems: 'center' }}>
                            <label><b>Reviewer Group*</b></label>
                            <input type="text" value={endReviewerGroup} readOnly disabled style={dateInputStyle} />
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', alignItems: 'center', marginTop: '10px' }}>
                            <label><b>Plan*</b></label>
                            <input type="text" value={endReviewPlan} readOnly disabled style={dateInputStyle} />
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', alignItems: 'center', marginTop: '10px' }}>
                            <label><b>Effective From Date*</b></label>
                            <input type="date" value={endReviewFromDate} readOnly disabled style={dateInputStyle} />
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', alignItems: 'center', marginTop: '10px' }}>
                            <label><b>Current Effective To Date*</b></label>
                            <input type="date" value={currentReviewEndToDate} readOnly disabled style={dateInputStyle} />
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', alignItems: 'center', marginTop: '10px' }}>
                            <label><b>Revised Effective To Date*</b></label>
                            <input type="date"
                                value={revisedReviewEndToDate} onChange={handleRevisedReviewEndDateChange}
                                style={dateInputStyle} />
                        </div>
                        <div style={{ marginTop: '18px', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                            <Button className="OkButton" onClick={handleSaveEndReview}>Confirm</Button>
                            <Button className="OkButton" onClick={() => setIsEndReviewModalOpen(false)}>Cancel</Button>
                        </div>
                    </Modal>

                    <Modal
                        isOpen={isNewMcoAuthorityModalOpen}
                        onRequestClose={() => setIsNewMcoAuthorityModalOpen(false)}
                        shouldCloseOnOverlayClick={false}
                        contentLabel="Add MCO Granting Authority"
                        style={{ content: { width: '600px', height: '500px', margin: 'auto', border: '2px solid #222' } }}
                    >
                        <h2 style={{ textAlign: 'center', marginBottom: '16px' }}><b>Add MCO Granting Authority</b></h2>
                        <div style={{ width: '80%', margin: '0 auto', display: 'grid', gap: '14px' }}>

                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', alignItems: 'center' }}>
                                <label><b>User/Email ID*</b></label>
                                <select
                                    value={mcoStaffNewValues.userEmailId || ""}
                                    onChange={(e) => {
                                        const selectedEmail = e.target.value;
                                        const selectedUser = mcoStaffUserDetailsList.find((u: any) => u.value === selectedEmail);

                                        setMcoStaffNewValues((prev) => ({
                                            ...prev,
                                            userEmailId: selectedEmail,
                                            userEmailId_userFirstName: selectedUser?.userFirstName || "",
                                            userEmailId_userLastName: selectedUser?.userLastName || "",
                                            userEmailId_userStaffCategory: selectedUser?.mcoStaffCtgryLkpcd || "",
                                            userEmailId_userJobTitle: selectedUser?.jobTitle || "",
                                        }));
                                    }}
                                    style={dateInputStyle}
                                >
                                    <option value="">-- Select Email Id --</option>
                                    {mcoStaffUserDetailsList.map((s: any) => (
                                        <option key={s.value} value={s.value}>{s.label}</option>
                                    ))}
                                </select>
                            </div>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', alignItems: 'center' }}>
                                <label><b>Name</b></label>
                                <input
                                    type="text"
                                    value={[

                                        mcoStaffNewValues.userEmailId_userLastName,
                                        mcoStaffNewValues.userEmailId_userFirstName
                                    ]
                                        .filter(Boolean)
                                        .join(", ")
                                    }
                                    onChange={() => ''}
                                    readOnly disabled style={dateInputStyle}
                                />
                            </div>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', alignItems: 'center' }}>
                                <label><b>Title</b></label>
                                <input
                                    type="text"
                                    value={mcoStaffNewValues.userEmailId_userJobTitle || ""}
                                    onChange={() => ''}
                                    readOnly disabled style={dateInputStyle}
                                />
                            </div>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', alignItems: 'center' }}>
                                <label><b>MCO Staff Category</b></label>
                                <input
                                    type="text"
                                    value={matchingMcoStaffCategoryLkpcd(mcoStaffNewValues.userEmailId_userStaffCategory) || ""}
                                    onChange={() => ''}
                                    readOnly disabled style={dateInputStyle}
                                />
                            </div>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', alignItems: 'center' }}>
                                <label><b>Authorization Document*</b></label>
                                <input
                                    type="file"
                                    onChange={handleMcoFileChange}
                                    style={dateInputStyle}
                                />
                            </div>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', alignItems: 'center' }}>
                                <label><b>Effective From Date*</b></label>
                                <input
                                    type="date"
                                    value={newMcoAuthFromDate}
                                    onChange={handleMcoAuthFromDateChange}
                                    min={getTodayDate()}
                                    style={dateInputStyle}
                                // onKeyDown={(e) => e.preventDefault()}
                                // onPaste={(e) => e.preventDefault()}
                                // onClick={(e) => {
                                //     const input = e.target as HTMLInputElement;
                                //     if (input.showPicker) {
                                //         input.showPicker();
                                //     }
                                // }}
                                />
                            </div>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', alignItems: 'center' }}>
                                <label><b>Effective To Date*</b></label>
                                <input
                                    type="date"
                                    value={newMcoAuthToDate}
                                    onChange={handleMcoAuthToDateChange}
                                    min={newMcoAuthFromDate || getTodayDate()}
                                    style={dateInputStyle}
                                // onKeyDown={(e) => e.preventDefault()}
                                // onPaste={(e) => e.preventDefault()}
                                // onClick={(e) => {
                                //     const input = e.target as HTMLInputElement;
                                //     if (input.showPicker) {
                                //         input.showPicker();
                                //     }
                                // }}
                                />
                            </div>
                            <div style={{ marginTop: '18px', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                                <Button className="OkButton" onClick={handleConfirmNewMcoAuthority} disabled={loadingButton || !mcoStaffNewValues.userEmailId || !mcoAuthorityFile || !newMcoAuthFromDate || !newMcoAuthToDate}>Confirm</Button>
                                <Button className="OkButton" onClick={handleCloseNewMcoAuthorityModal}>Cancel</Button>
                            </div>
                        </div>
                    </Modal>

                    <Modal
                        isOpen={isEndMcoAuthorityModalOpen}
                        onRequestClose={() => setIsEndMcoAuthorityModalOpen(false)}
                        shouldCloseOnOverlayClick={false}
                        contentLabel="End MCO Granting Authority"
                        style={{ content: { width: '600px', height: '360px', margin: 'auto', border: '2px solid #222' } }}
                    >
                        <h2 style={{ textAlign: 'center', marginBottom: '16px' }}><b>End MCO Granting Authority</b></h2>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', alignItems: 'center' }}>
                            <label><b>User/Email ID*</b></label>
                            <input type="text" value={mcoAuthEditEmailId} readOnly disabled style={dateInputStyle} />
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', alignItems: 'center', marginTop: '10px' }}>
                            <label><b>Name</b></label>
                            <input type="text" value={mcoAuthEditName} readOnly disabled style={dateInputStyle} />
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', alignItems: 'center', marginTop: '10px' }}>
                            <label><b>Title</b></label>
                            <input type="text" value={mcoAuthEditTitle} readOnly disabled style={dateInputStyle} />
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', alignItems: 'center', marginTop: '10px' }}>
                            <label><b>MCO Staff Category</b></label>
                            <input type="text" value={matchingMcoStaffCategoryLkpcd(mcoAuthEditStaffCtgry)} readOnly disabled style={dateInputStyle} />
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', alignItems: 'center', marginTop: '10px' }}>
                            <label><b>Authorization Document</b></label>
                            <input type="text" value={mcoAuthFileEditName} readOnly disabled style={dateInputStyle} />
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', alignItems: 'center', marginTop: '10px' }}>
                            <label><b>Effective From Date*</b></label>
                            <input type="date" value={mcoAuthFromEditDate} readOnly disabled style={dateInputStyle} />
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', alignItems: 'center', marginTop: '10px' }}>
                            <label><b>Current Effective To Date*</b></label>
                            <input type="date" value={mcoAuthToEditDate} readOnly disabled style={dateInputStyle} />
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', alignItems: 'center', marginTop: '10px' }}>
                            <label><b>Revised Effective To Date*</b></label>
                            <input type="date"
                                value={revisedStaffEndToDate}
                                onChange={handleRevisedStaffEndDateChange}
                                style={dateInputStyle} />
                        </div>
                        <div style={{ marginTop: '18px', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                            <Button className="OkButton" onClick={handleSaveEndMcoAuthority}>Confirm</Button>
                            <Button className="OkButton" onClick={() => setIsEndMcoAuthorityModalOpen(false)}>Cancel</Button>
                        </div>
                    </Modal>

                </>
            }

            <Footer />
        </>
    );
}